export const IconComment = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 22 22"
    fill="none"
  >
    <mask
      id="mask0_947_1342"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="22"
      height="22"
      mask-type="alpha"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.000488281H21.493V21.4943H0V0.000488281Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_947_1342)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10838 18.6755C5.68838 18.6755 6.23538 18.8955 6.81438 19.1285C10.3614 20.7685 14.5564 20.0225 17.2894 17.2905C20.8954 13.6825 20.8954 7.81349 17.2894 4.20749C15.5434 2.46149 13.2214 1.50049 10.7494 1.50049C8.27638 1.50049 5.95338 2.46249 4.20838 4.20849C1.47438 6.94049 0.730376 11.1355 2.35538 14.6485C2.58938 15.2275 2.81538 15.7915 2.81538 16.3775C2.81538 16.9625 2.61438 17.5515 2.43738 18.0715C2.29138 18.4995 2.07038 19.1455 2.21238 19.2875C2.35138 19.4315 3.00138 19.2045 3.43038 19.0575C3.94538 18.8815 4.52938 18.6795 5.10838 18.6755V18.6755ZM10.7244 21.4945C9.19638 21.4945 7.65838 21.1715 6.21938 20.5055C5.79538 20.3355 5.39838 20.1755 5.11338 20.1755C4.78538 20.1775 4.34438 20.3295 3.91838 20.4765C3.04438 20.7765 1.95638 21.1505 1.15138 20.3485C0.349376 19.5455 0.719376 18.4605 1.01738 17.5875C1.16438 17.1575 1.31538 16.7135 1.31538 16.3775C1.31538 16.1015 1.18238 15.7495 0.978376 15.2425C-0.894624 11.1975 -0.0286238 6.32249 3.14838 3.14749C5.17638 1.11849 7.87538 0.000488281 10.7484 0.000488281C13.6214 0.000488281 16.3214 1.11749 18.3494 3.14649C22.5414 7.33849 22.5414 14.1585 18.3494 18.3505C16.2944 20.4065 13.5274 21.4945 10.7244 21.4945V21.4945Z"
        fill="#97A0AF"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6963 12.1631C14.1443 12.1631 13.6923 11.7161 13.6923 11.1631C13.6923 10.6101 14.1353 10.1631 14.6873 10.1631H14.6963C15.2483 10.1631 15.6963 10.6101 15.6963 11.1631C15.6963 11.7161 15.2483 12.1631 14.6963 12.1631"
      fill="#97A0AF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6875 12.1631C10.1355 12.1631 9.68347 11.7161 9.68347 11.1631C9.68347 10.6101 10.1255 10.1631 10.6785 10.1631H10.6875C11.2395 10.1631 11.6875 10.6101 11.6875 11.1631C11.6875 11.7161 11.2395 12.1631 10.6875 12.1631"
      fill="#97A0AF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.67832 12.1631C6.12632 12.1631 5.67432 11.7161 5.67432 11.1631C5.67432 10.6101 6.11732 10.1631 6.66932 10.1631H6.67832C7.23032 10.1631 7.67832 10.6101 7.67832 11.1631C7.67832 11.7161 7.23032 12.1631 6.67832 12.1631"
      fill="#97A0AF"
    />
  </svg>
);

export const IconLike = ({ isLiked }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    {isLiked && (
      <path
        d="M15.71 0.790701C15.111 0.589701 14.481 0.500701 13.85 0.500701C12.46 0.490701 11.111 0.950701 10 1.7997C9.91002 1.7307 9.80002 1.6697 9.70002 1.6107C9.60002 1.5497 9.42002 1.4007 9.27002 1.3207L8.89002 1.1507C8.69002 1.0407 8.48102 0.960701 8.26002 0.889701C8.24002 0.870701 8.21002 0.849701 8.17002 0.830701H8.11102C7.52002 0.629701 6.91002 0.519701 6.28002 0.500701H6.17002C5.89002 0.500701 5.61102 0.519701 5.33002 0.560701H5.21002C4.91002 0.599701 4.61102 0.669701 4.32102 0.769701C0.590017 1.9907 -0.739983 6.0407 0.390017 9.5807C1.03002 11.3897 2.06102 13.0307 3.40102 14.3797C5.35002 16.2597 7.48102 17.9197 9.77002 19.3397L10.03 19.5007L10.28 19.3497C12.561 17.9197 14.68 16.2597 16.611 14.3897C17.96 13.0407 18.99 11.3897 19.62 9.5807C20.731 6.0407 19.401 1.9907 15.71 0.790701Z"
        fill="red"
      />
    )}

    {!isLiked && (
      <>
        <mask
          id="mask0_947_1333"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="21"
          height="20"
          mask-type="alpha"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H20.4725V19.501H0V0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_947_1333)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.82371 9.12312C3.22571 13.4851 8.76471 17.0121 10.2367 17.8851C11.7137 17.0031 17.2927 13.4371 18.6497 9.12712C19.5407 6.34112 18.7137 2.81212 15.4277 1.75312C13.8357 1.24212 11.9787 1.55312 10.6967 2.54512C10.4287 2.75112 10.0567 2.75512 9.78671 2.55112C8.42871 1.53012 6.65471 1.23112 5.03771 1.75312C1.75671 2.81112 0.932712 6.34012 1.82371 9.12312ZM10.2377 19.5011C10.1137 19.5011 9.99071 19.4711 9.87871 19.4101C9.56571 19.2391 2.19271 15.1751 0.395713 9.58112C0.394713 9.58112 0.394713 9.58012 0.394713 9.58012C-0.733288 6.05812 0.522713 1.63212 4.57771 0.325118C6.48171 -0.290882 8.55671 -0.019882 10.2347 1.03912C11.8607 0.011118 14.0207 -0.272882 15.8867 0.325118C19.9457 1.63412 21.2057 6.05912 20.0787 9.58012C18.3397 15.1101 10.9127 19.2351 10.5977 19.4081C10.4857 19.4701 10.3617 19.5011 10.2377 19.5011Z"
            fill="#97A0AF"
          />
        </g>
      </>
    )}
  </svg>
);

export const IconLoading = ({ color }) => (
  <svg
    className={`animate-spin h-5 w-5 ${
      color ? `text-[${color}]` : "text-branding-500"
    }`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

export const IconPrize = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M12.3101 0.938839C10.5027 0.355267 8.55741 0.355267 6.74995 0.938839C5.86774 1.26504 5.38215 1.75619 5.38215 2.31777V4.69382C5.03927 4.66417 4.74829 4.65119 4.47398 4.65119C3.52896 4.63512 2.58832 4.78311 1.69389 5.08859C0.817232 5.42406 0.333496 5.91706 0.333496 6.47493V11.7942C0.333496 12.3502 0.817232 12.8451 1.69389 13.1731C3.50141 13.7563 5.44656 13.7563 7.25408 13.1731C7.97505 12.8988 8.42728 12.5263 8.56813 12.0907C8.88536 12.1215 9.20392 12.1363 9.52263 12.1352C10.4677 12.1516 11.4084 12.0036 12.3027 11.6978C13.1812 11.3698 13.665 10.8786 13.665 10.317V2.31035C13.6779 1.75619 13.1887 1.26689 12.3101 0.938839ZM8.61632 10.1261C8.89804 10.1539 9.19644 10.1669 9.52449 10.1669C10.4694 10.1839 11.4101 10.0365 12.3046 9.73135C12.4885 9.66356 12.6669 9.58177 12.8384 9.4867V10.33C12.8384 10.6766 11.5799 11.3123 9.52634 11.3123C9.2231 11.3133 8.91999 11.2991 8.61818 11.2697L8.61632 10.1261ZM9.52449 9.33287C9.22124 9.33392 8.91814 9.31969 8.61632 9.29024V8.14855C8.89804 8.17635 9.19644 8.18933 9.52449 8.18933C10.4695 8.20574 11.4102 8.05773 12.3046 7.75192C12.4891 7.68569 12.6677 7.60384 12.8384 7.50728V8.34501C12.8365 8.69345 11.5781 9.33472 9.52449 9.33472V9.33287ZM9.52449 7.359C9.22127 7.36061 8.91817 7.347 8.61632 7.31823V6.47493C8.61598 6.3722 8.59908 6.27019 8.56629 6.17283C8.89619 6.20248 9.21126 6.21731 9.52449 6.21731C10.4695 6.23372 11.4102 6.08572 12.3046 5.77991C12.4885 5.71212 12.6669 5.63033 12.8384 5.53526V6.373C12.8365 6.70846 11.667 7.36086 9.52449 7.36086V7.359ZM12.8365 3.4539V4.39357C12.8365 4.72903 11.667 5.38143 9.52449 5.38143C7.46907 5.38143 6.21247 4.74201 6.21247 4.39357V3.4539C6.38324 3.54897 6.56107 3.63076 6.74439 3.69855C7.63894 4.00336 8.57958 4.15073 9.52449 4.13409C10.4694 4.1511 11.4101 4.00373 12.3046 3.69855C12.4879 3.63066 12.6657 3.54888 12.8365 3.4539ZM9.52449 3.30748C7.46907 3.30748 6.21247 2.6662 6.21247 2.31777C6.21247 1.96933 7.46907 1.32249 9.52449 1.32249C11.5799 1.32249 12.8365 1.96191 12.8365 2.31035C12.8365 2.65879 11.5781 3.30748 9.52449 3.30748ZM7.78786 11.2048V11.809C7.78786 12.1574 6.5294 12.7969 4.47584 12.7969C2.42227 12.7969 1.16382 12.1649 1.16382 11.809V11.2048C1.33459 11.2999 1.51242 11.3817 1.69574 11.4494C3.50326 12.0326 5.44841 12.0326 7.25593 11.4494C7.4391 11.3813 7.61691 11.2995 7.78786 11.2048ZM4.47584 11.0528C2.42227 11.0528 1.16382 10.4115 1.16382 10.0631V9.46632C1.33459 9.56139 1.51242 9.64318 1.69574 9.71096C3.50326 10.2942 5.44841 10.2942 7.25593 9.71096C7.43925 9.64318 7.61708 9.56139 7.78786 9.46632V10.0687C7.78786 10.4041 6.61836 11.0528 4.47584 11.0528ZM4.47584 9.31434C2.42227 9.31434 1.16382 8.67306 1.16382 8.32462V7.61107C1.33459 7.70614 1.51242 7.78793 1.69574 7.85571C3.50356 8.43703 5.44812 8.43703 7.25593 7.85571C7.43925 7.78793 7.61708 7.70614 7.78786 7.61107V8.33018C7.78786 8.66565 6.61836 9.3199 4.47584 9.3199V9.31434ZM4.47584 7.46094C2.42227 7.46094 1.16382 6.82152 1.16382 6.47308C1.16382 6.12464 2.42227 5.47781 4.47584 5.47781C4.89255 5.47494 5.30889 5.50344 5.72132 5.56306C5.73293 5.56551 5.74493 5.56551 5.75654 5.56306C7.08171 5.7484 7.79527 6.2099 7.79527 6.46567C7.78786 6.8104 6.61836 7.46279 4.47584 7.46279V7.46094Z"
      fill="#97A0AF"
    />
  </svg>
);

export const IconArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
  >
    <path
      d="M17 7.27393C17 7.65362 16.7178 7.96742 16.3518 8.01708L16.25 8.02393L1.25 8.02393C0.835786 8.02393 0.5 7.68814 0.5 7.27393C0.5 6.89423 0.782154 6.58043 1.14823 6.53077L1.25 6.52393L16.25 6.52393C16.6642 6.52393 17 6.85971 17 7.27393Z"
      fill="white"
    />
    <path
      d="M7.82899 12.767C8.12251 13.0593 8.12354 13.5342 7.83128 13.8277C7.56558 14.0945 7.14897 14.1196 6.85489 13.9024L6.77062 13.83L0.720618 7.80598C0.452981 7.5395 0.428634 7.12138 0.647588 6.82731L0.720574 6.74308L6.77057 0.718085C7.06407 0.425799 7.53895 0.426782 7.83123 0.720281C8.09695 0.987098 8.12029 1.40381 7.90183 1.69697L7.82904 1.78094L2.313 7.27481L7.82899 12.767Z"
      fill="white"
    />
  </svg>
);

export const IconGame = ({ size = 19 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.16459 13.7999C6.81959 13.7999 6.53959 13.5199 6.53959 13.1749V10.0541C6.53959 9.70907 6.81959 9.42907 7.16459 9.42907C7.50959 9.42907 7.78959 9.70907 7.78959 10.0541V13.1749C7.78959 13.5199 7.50959 13.7999 7.16459 13.7999Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75684 12.239H5.57267C5.22767 12.239 4.94767 11.959 4.94767 11.614C4.94767 11.269 5.22767 10.989 5.57267 10.989H8.75684C9.10184 10.989 9.38184 11.269 9.38184 11.614C9.38184 11.959 9.10184 12.239 8.75684 12.239Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5963 10.7742H12.5072C12.1622 10.7742 11.8822 10.4942 11.8822 10.1492C11.8822 9.80416 12.1622 9.52416 12.5072 9.52416H12.5963C12.9413 9.52416 13.2213 9.80416 13.2213 10.1492C13.2213 10.4942 12.9413 10.7742 12.5963 10.7742Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1076 13.7527H14.0184C13.6734 13.7527 13.3934 13.4727 13.3934 13.1277C13.3934 12.7827 13.6734 12.5027 14.0184 12.5027H14.1076C14.4526 12.5027 14.7326 12.7827 14.7326 13.1277C14.7326 13.4727 14.4526 13.7527 14.1076 13.7527Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3011 5.49016C9.95605 5.49016 9.67605 5.21016 9.67605 4.86516V4.30266C9.67355 3.69933 9.16189 3.2035 8.53605 3.201H7.65772C6.68522 3.201 5.89272 2.41933 5.89272 1.4585C5.89272 1.1135 6.17272 0.833496 6.51772 0.833496C6.86355 0.833496 7.14272 1.1135 7.14272 1.4585C7.14272 1.73016 7.37355 1.951 7.65772 1.951H8.53855C9.84939 1.95516 10.9202 3.0085 10.9261 4.29933V4.86516C10.9261 5.21016 10.6461 5.49016 10.3011 5.49016Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75051 5.72775C8.52051 5.72775 7.30551 5.73858 6.11217 5.75858C3.77301 5.75858 2.08301 7.40691 2.08301 9.67691V13.5519C2.08301 15.8211 3.77301 17.4694 6.10217 17.4694C8.55801 17.5102 11.0338 17.5102 13.4705 17.4694H13.4813C15.8097 17.4694 17.4997 15.8211 17.4997 13.5519V9.67691C17.4997 7.40691 15.8097 5.75858 13.4813 5.75858C12.228 5.73858 10.9822 5.72775 9.75051 5.72775ZM9.79467 18.7502C8.55884 18.7502 7.32134 18.7394 6.09134 18.7194C3.04884 18.7194 0.833008 16.5452 0.833008 13.5519V9.67691C0.833008 6.68275 3.04884 4.50858 6.10217 4.50858C8.49301 4.46775 10.983 4.46775 13.4913 4.50858C16.5338 4.50858 18.7497 6.68275 18.7497 9.67691V13.5519C18.7497 16.5436 16.5372 18.7169 13.4863 18.7194C12.263 18.7394 11.0297 18.7502 9.79467 18.7502Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAdd = ({ size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1Z"
      fill="white"
    />
  </svg>
);

export const IconEdit = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size + 1}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0322 0.382361C13.421 0.0709509 12.6977 0.0709514 12.0865 0.382361C11.7809 0.538072 11.5152 0.804459 11.2078 1.11265L1.81431 10.5062C1.56138 10.7591 1.37967 10.9407 1.23038 11.1462C0.932227 11.5565 0.735431 12.0316 0.65608 12.5326C0.616348 12.7835 0.61641 13.0404 0.616497 13.398L0.616505 14.1428L0.616363 14.2006C0.61563 14.4019 0.614729 14.6493 0.686426 14.87C0.827737 15.3049 1.16871 15.6459 1.60362 15.7872C1.82428 15.8589 2.07168 15.858 2.27295 15.8572L2.33079 15.8571L3.07556 15.8571C3.43317 15.8572 3.69009 15.8572 3.94094 15.8175C4.44194 15.7382 4.91705 15.5414 5.32742 15.2432C5.5329 15.0939 5.71452 14.9122 5.96732 14.6593L15.3609 5.26578C15.6691 4.95836 15.9355 4.69265 16.0912 4.38705C16.4026 3.77588 16.4026 3.05256 16.0912 2.44138C15.9355 2.13579 15.6691 1.87008 15.3609 1.56268L14.9109 1.11266C14.6035 0.804463 14.3378 0.538073 14.0322 0.382361ZM12.7351 1.65523C12.9388 1.55142 13.1799 1.55142 13.3836 1.65523C13.459 1.69364 13.5532 1.7753 13.9685 2.19065L14.2829 2.50508C14.6983 2.92043 14.7799 3.01455 14.8183 3.08994C14.9222 3.29366 14.9222 3.53477 14.8183 3.7385C14.7799 3.81389 14.6983 3.90801 14.2829 4.32336L13.6701 4.93622L11.5374 2.80352L12.1502 2.19065C12.5656 1.7753 12.6597 1.69364 12.7351 1.65523ZM10.5272 3.81367L2.86099 11.4799C2.55709 11.7838 2.46104 11.8827 2.38612 11.9858C2.22048 12.2138 2.11115 12.4778 2.06706 12.7561C2.04712 12.882 2.04508 13.0199 2.04508 13.4497V14.1428C2.04508 14.2835 2.04533 14.3605 2.04838 14.4164L2.04887 14.4247L2.0572 14.4252C2.11311 14.4283 2.19006 14.4285 2.33079 14.4285H3.0239C3.45368 14.4285 3.59157 14.4265 3.71746 14.4065C3.9958 14.3624 4.25975 14.2531 4.48773 14.0875C4.59085 14.0126 4.6898 13.9165 4.9937 13.6126L12.6599 5.94638L10.5272 3.81367Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCalendar = ({ size = 19 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 2}
    height={size}
    viewBox="0 0 17 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2221 8.25366H1.36877C1.02377 8.25366 0.743774 7.97366 0.743774 7.62866C0.743774 7.28366 1.02377 7.00366 1.36877 7.00366H16.2221C16.5671 7.00366 16.8471 7.28366 16.8471 7.62866C16.8471 7.97366 16.5671 8.25366 16.2221 8.25366Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.501 11.5081C12.156 11.5081 11.8727 11.2281 11.8727 10.8831C11.8727 10.5381 12.1485 10.2581 12.4935 10.2581H12.501C12.846 10.2581 13.126 10.5381 13.126 10.8831C13.126 11.2281 12.846 11.5081 12.501 11.5081Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.80308 11.5081C8.45808 11.5081 8.17474 11.2281 8.17474 10.8831C8.17474 10.5381 8.45058 10.2581 8.79558 10.2581H8.80308C9.14808 10.2581 9.42808 10.5381 9.42808 10.8831C9.42808 11.2281 9.14808 11.5081 8.80308 11.5081Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.09743 11.5081C4.75243 11.5081 4.46826 11.2281 4.46826 10.8831C4.46826 10.5381 4.74493 10.2581 5.08993 10.2581H5.09743C5.44243 10.2581 5.72243 10.5381 5.72243 10.8831C5.72243 11.2281 5.44243 11.5081 5.09743 11.5081Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.501 14.7469C12.156 14.7469 11.8727 14.4669 11.8727 14.1219C11.8727 13.7769 12.1485 13.4969 12.4935 13.4969H12.501C12.846 13.4969 13.126 13.7769 13.126 14.1219C13.126 14.4669 12.846 14.7469 12.501 14.7469Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.80308 14.7469C8.45808 14.7469 8.17474 14.4669 8.17474 14.1219C8.17474 13.7769 8.45058 13.4969 8.79558 13.4969H8.80308C9.14808 13.4969 9.42808 13.7769 9.42808 14.1219C9.42808 14.4669 9.14808 14.7469 8.80308 14.7469Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.09743 14.7469C4.75243 14.7469 4.46826 14.4669 4.46826 14.1219C4.46826 13.7769 4.74493 13.4969 5.08993 13.4969H5.09743C5.44243 13.4969 5.72243 13.7769 5.72243 14.1219C5.72243 14.4669 5.44243 14.7469 5.09743 14.7469Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1613 4.82587C11.8163 4.82587 11.5363 4.54587 11.5363 4.20087V1.45837C11.5363 1.11337 11.8163 0.833374 12.1613 0.833374C12.5063 0.833374 12.7863 1.11337 12.7863 1.45837V4.20087C12.7863 4.54587 12.5063 4.82587 12.1613 4.82587Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.42944 4.82587C5.08444 4.82587 4.80444 4.54587 4.80444 4.20087V1.45837C4.80444 1.11337 5.08444 0.833374 5.42944 0.833374C5.77444 0.833374 6.05444 1.11337 6.05444 1.45837V4.20087C6.05444 4.54587 5.77444 4.82587 5.42944 4.82587Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1452_1331"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="2"
      width="17"
      height="17"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666687 2.14929H16.9167V18.75H0.666687V2.14929Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_1331)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.26752 3.39929C3.10669 3.39929 1.91669 4.55179 1.91669 6.64429V14.1851C1.91669 16.3235 3.10669 17.5001 5.26752 17.5001H12.3159C14.4767 17.5001 15.6667 16.3451 15.6667 14.2485V6.64429C15.67 5.61513 15.3934 4.81513 14.8442 4.26513C14.2792 3.69846 13.4084 3.39929 12.3234 3.39929H5.26752ZM12.3159 18.7501H5.26752C2.43002 18.7501 0.666687 17.001 0.666687 14.1851V6.64429C0.666687 3.87096 2.43002 2.14929 5.26752 2.14929H12.3234C13.7475 2.14929 14.925 2.57596 15.7292 3.38179C16.51 4.16596 16.9209 5.29346 16.9167 6.64596V14.2485C16.9167 17.0251 15.1534 18.7501 12.3159 18.7501Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconGenre = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 2}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25388 6.46807C5.25388 4.89666 6.52776 3.62278 8.09917 3.62278C9.67059 3.62278 10.9445 4.89666 10.9445 6.46807C10.9445 8.03948 9.67059 9.31337 8.09917 9.31337C6.52776 9.31337 5.25388 8.03948 5.25388 6.46807ZM8.09917 5.10085C7.34408 5.10085 6.73195 5.71298 6.73195 6.46807C6.73195 7.22317 7.34408 7.83529 8.09917 7.83529C8.85427 7.83529 9.46639 7.22317 9.46639 6.46807C9.46639 5.71298 8.85427 5.10085 8.09917 5.10085Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.12791 0.666626H12.0703C12.5624 0.666616 12.976 0.666607 13.3143 0.694254C13.6681 0.72316 14.0044 0.785934 14.3235 0.948553C14.8102 1.19654 15.2059 1.59225 15.4539 2.07895C15.6165 2.39811 15.6793 2.73434 15.7082 3.08814C15.7359 3.42651 15.7359 3.84 15.7358 4.33208V11.8554C15.7359 12.3475 15.7359 12.761 15.7082 13.0994C15.6793 13.4532 15.6165 13.7894 15.4539 14.1086C15.2059 14.5953 14.8102 14.991 14.3235 15.2389C14.0044 15.4016 13.6681 15.4643 13.3143 15.4932C12.976 15.5209 12.5625 15.5209 12.0704 15.5209H11.9647C11.4605 15.5209 11.3137 15.5245 11.1804 15.5526C11.0468 15.5808 10.9176 15.6273 10.7967 15.6909C10.6762 15.7544 10.5608 15.8452 10.1726 16.167L9.68455 16.5715C9.49872 16.7255 9.3293 16.866 9.17772 16.9736C9.01363 17.0901 8.82912 17.1991 8.60427 17.2629C8.27419 17.3567 7.92452 17.3567 7.59443 17.263C7.36957 17.1991 7.18506 17.0902 7.02096 16.9737C6.86937 16.8661 6.69997 16.7257 6.51413 16.5717L6.02559 16.1668C5.63743 15.8452 5.52204 15.7543 5.40153 15.6909C5.28066 15.6273 5.15155 15.5808 5.01789 15.5526C4.88464 15.5245 4.73783 15.5209 4.23371 15.5209H4.1279C3.63582 15.5209 3.22229 15.5209 2.88391 15.4932C2.53012 15.4643 2.19389 15.4016 1.87473 15.2389C1.38802 14.991 0.992319 14.5953 0.74433 14.1086C0.58171 13.7894 0.518936 13.4532 0.49003 13.0994C0.462383 12.761 0.462392 12.3475 0.462403 11.8554V4.33214C0.462392 3.84004 0.462383 3.42652 0.49003 3.08814C0.518936 2.73434 0.58171 2.39811 0.74433 2.07895C0.992319 1.59225 1.38802 1.19654 1.87473 0.948553C2.19389 0.785934 2.53012 0.72316 2.88391 0.694254C3.22229 0.666607 3.63582 0.666616 4.12791 0.666626ZM3.00428 2.16742C2.74189 2.18886 2.62182 2.22677 2.54576 2.26553C2.33717 2.37181 2.16759 2.5414 2.0613 2.74998C2.02255 2.82605 1.98463 2.94611 1.9632 3.2085C1.94105 3.47952 1.94048 3.83225 1.94048 4.36182V11.8257C1.94048 12.3553 1.94105 12.708 1.9632 12.979C1.98463 13.2414 2.02255 13.3615 2.0613 13.4375C2.16759 13.6461 2.33717 13.8157 2.54576 13.922C2.56725 13.9329 2.59225 13.9438 2.62299 13.9543C3.50364 11.796 5.62286 10.2741 8.09918 10.2741C10.5755 10.2741 12.6947 11.796 13.5754 13.9542C13.6061 13.9438 13.631 13.9329 13.6525 13.922C13.8611 13.8157 14.0307 13.6461 14.1369 13.4375C14.1757 13.3615 14.2136 13.2414 14.2351 12.979C14.2572 12.708 14.2578 12.3553 14.2578 11.8257V4.36181C14.2578 3.83225 14.2572 3.47952 14.2351 3.2085C14.2136 2.94611 14.1757 2.82605 14.1369 2.74998C14.0307 2.5414 13.8611 2.37181 13.6525 2.26553C13.5764 2.22677 13.4564 2.18886 13.194 2.16742C12.923 2.14528 12.5702 2.1447 12.0407 2.1447H4.15759C3.62802 2.1447 3.27529 2.14528 3.00428 2.16742ZM11.982 14.0428C11.2261 12.6766 9.76993 11.7522 8.09918 11.7522C6.42844 11.7522 4.97227 12.6766 4.21635 14.0428L4.29919 14.0428C4.70952 14.0426 5.01968 14.0425 5.32253 14.1063C5.58984 14.1626 5.84806 14.2557 6.08982 14.3829C6.36371 14.527 6.60244 14.725 6.91828 14.9869L7.43907 15.4185C7.64892 15.5924 7.77553 15.6967 7.87659 15.7684C7.9233 15.8016 7.9534 15.8196 7.97259 15.8297C7.98973 15.8387 7.99705 15.8408 7.99825 15.8411C8.06427 15.8599 8.13426 15.8599 8.20028 15.8411C8.20147 15.8408 8.20884 15.8387 8.226 15.8297C8.24518 15.8196 8.27529 15.8016 8.32199 15.7684C8.42305 15.6967 8.54964 15.5924 8.75948 15.4185L9.27986 14.9871C9.59571 14.7251 9.83447 14.5271 10.1084 14.3829C10.3502 14.2557 10.6084 14.1626 10.8758 14.1063C11.1786 14.0425 11.4888 14.0426 11.8992 14.0428L11.982 14.0428Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPersonalities = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 2}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.98622 3.29749C5.59823 3.22621 5.22591 3.48297 5.15464 3.87096C5.1039 4.14714 4.74046 4.73263 3.72752 4.71389C3.3331 4.7066 3.00744 5.02043 3.00015 5.41485C2.99285 5.80927 3.30668 6.13493 3.70111 6.14222C5.37868 6.17324 6.37644 5.12668 6.5597 4.12907C6.63098 3.74108 6.37422 3.36876 5.98622 3.29749Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3325 4.01998C10.716 3.92745 11.1019 4.16331 11.1944 4.5468C11.3073 5.01461 11.4746 5.45103 11.7382 5.74577C11.9652 5.99958 12.3021 6.19597 12.925 6.13017C13.3173 6.08873 13.6689 6.37316 13.7104 6.76547C13.7518 7.15778 13.4674 7.5094 13.0751 7.55084C12.0039 7.66399 11.2121 7.30051 10.6734 6.69811C10.1712 6.13664 9.93563 5.42051 9.80567 4.88187C9.71314 4.49839 9.94901 4.1125 10.3325 4.01998Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.54932 14.3555C5.15577 14.3827 4.81467 14.0857 4.78744 13.6922C4.75368 13.2042 4.66508 12.7992 4.44549 12.4504C4.23186 12.1111 3.84803 11.7527 3.09091 11.4485C2.72486 11.3015 2.54731 10.8855 2.69436 10.5195C2.84141 10.1534 3.25737 9.97588 3.62342 10.1229C4.59803 10.5144 5.24824 11.0442 5.65442 11.6893C6.05463 12.325 6.17161 13.0008 6.21261 13.5936C6.23983 13.9871 5.94287 14.3282 5.54932 14.3555Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.15464 3.87096C5.22591 3.48297 5.59823 3.22621 5.98622 3.29749C6.37422 3.36876 6.63098 3.74108 6.5597 4.12907C6.37644 5.12668 5.37868 6.17324 3.70111 6.14222C3.30668 6.13493 2.99285 5.80927 3.00015 5.41485C3.00744 5.02043 3.3331 4.7066 3.72752 4.71389C4.74046 4.73263 5.1039 4.14714 5.15464 3.87096ZM4.78744 13.6922C4.81467 14.0857 5.15577 14.3827 5.54932 14.3555C5.94287 14.3282 6.23983 13.9871 6.21261 13.5936C6.17161 13.0008 6.05463 12.325 5.65442 11.6893C5.24824 11.0442 4.59803 10.5144 3.62342 10.1229C3.25737 9.97588 2.84141 10.1534 2.69436 10.5195C2.54731 10.8855 2.72486 11.3015 3.09091 11.4485C3.84803 11.7527 4.23186 12.1111 4.44549 12.4504C4.66508 12.7992 4.75368 13.2042 4.78744 13.6922Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.30289 0.428589C4.85316 0.428589 3.61324 1.29249 3.0321 2.52703C1.33944 3.03974 0.142883 4.68223 0.142883 6.57686C0.142883 7.43792 0.38855 8.24301 0.813736 8.91437C0.43524 9.4022 0.212442 10.0223 0.212442 10.6901C0.212442 11.7055 0.730868 12.6195 1.53315 13.1158C1.4984 13.2818 1.48019 13.4539 1.48019 13.6297C1.48019 14.9181 2.52295 16.066 3.84251 16.0244C4.34867 16.9424 5.31512 17.5714 6.43657 17.5714C7.0132 17.5714 7.55089 17.404 8.00526 17.1164C8.46627 17.4044 9.01092 17.5714 9.59404 17.5714C10.7461 17.5714 11.7425 16.9226 12.2507 15.9736C13.5129 15.9572 14.4728 14.887 14.4728 13.6437C14.4728 13.4561 14.4513 13.2731 14.4104 13.0973C15.2817 12.6172 15.8572 11.6659 15.8572 10.599C15.8572 9.89584 15.6089 9.24686 15.1924 8.74808C15.4126 8.36523 15.5776 7.94463 15.6766 7.49853C15.7203 7.30154 15.7512 7.09959 15.7683 6.89371C15.7787 6.76869 15.784 6.64222 15.784 6.51454C15.784 4.63423 14.6333 3.00684 12.9896 2.40844C12.3184 1.22858 11.0545 0.428591 9.60083 0.428591C8.9981 0.428591 8.42604 0.566677 7.91545 0.813207C7.42999 0.567353 6.88212 0.428589 6.30289 0.428589ZM6.30289 1.85716C5.35656 1.85716 4.53666 2.47709 4.2316 3.36467C4.1484 3.60675 3.942 3.78581 3.69059 3.83401C2.51708 4.05899 1.57145 5.17387 1.57145 6.57686C1.57145 7.09841 1.70329 7.58309 1.93025 7.99686C1.9918 7.96267 2.05399 7.93026 2.11666 7.89963C3.03778 7.44942 4.17322 7.32316 5.12272 7.65012C5.49572 7.77857 5.69396 8.18506 5.56552 8.55805C5.43708 8.93105 5.03058 9.12929 4.65759 9.00085C4.12073 8.81598 3.37931 8.87257 2.74397 9.1831C2.16163 9.46773 1.64101 10.0087 1.64101 10.6901C1.64101 11.3757 2.08352 11.9058 2.6139 12.0412C2.83186 12.0969 3.01086 12.252 3.09699 12.4598C3.18313 12.6676 3.16634 12.9039 3.05168 13.0974C2.96255 13.2478 2.90876 13.4297 2.90876 13.6297C2.90876 14.2073 3.33752 14.5969 3.77245 14.5969C3.86487 14.5969 3.95287 14.5809 4.03532 14.5512C4.21999 14.4849 4.42381 14.4975 4.59894 14.586C4.77406 14.6745 4.90507 14.8311 4.96121 15.0191C5.1584 15.6796 5.75278 16.1429 6.43657 16.1429C6.74933 16.1429 7.04103 16.0472 7.28574 15.8802V12.8875L7.28572 12.8827V6.53959L7.28574 6.53475V2.09567C6.98975 1.94271 6.65625 1.85716 6.30289 1.85716ZM9.60083 1.85716C10.5884 1.85716 11.4459 2.44314 11.8427 3.2989C11.931 3.48935 12.0987 3.63131 12.3011 3.68705C13.4625 4.00687 14.3554 5.13443 14.3554 6.51454C14.3554 6.59978 14.352 6.6841 14.3453 6.76735C14.3339 6.9043 14.3143 7.03933 14.2853 7.17365C14.1605 7.71233 13.8553 8.27571 13.4189 8.73713C12.8769 9.31008 12.2096 9.64736 11.5714 9.64736C11.177 9.64736 10.8572 9.96715 10.8572 10.3616C10.8572 10.7561 11.177 11.0759 11.5714 11.0759C12.6107 11.0759 13.5517 10.5859 14.2623 9.91326C14.3675 10.1142 14.4286 10.3475 14.4286 10.599C14.4286 11.3215 13.9307 11.8788 13.3378 11.9804C13.0964 12.0217 12.893 12.1839 12.7989 12.41C12.7048 12.6362 12.7332 12.8948 12.8741 13.0952C12.9794 13.245 13.0442 13.4338 13.0442 13.6437C13.0442 14.165 12.6568 14.5448 12.2464 14.5448C11.836 14.5448 11.6514 14.3937 11.382 14.1542C11.0869 13.8918 10.9918 13.6365 10.9918 13.5245C10.9918 13.13 10.672 12.8102 10.2775 12.8102C9.88301 12.8102 9.56322 13.13 9.56322 13.5245C9.56322 14.2014 9.97383 14.8138 10.4328 15.2218C10.5568 15.3321 10.694 15.4363 10.8416 15.53C10.5498 15.9045 10.0976 16.1429 9.59404 16.1429C9.2688 16.1429 8.96662 16.0444 8.71432 15.8738V2.02238C8.98917 1.91565 9.28779 1.85716 9.60083 1.85716Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.15464 3.87096C5.22591 3.48297 5.59823 3.22621 5.98622 3.29749C6.37422 3.36876 6.63098 3.74108 6.5597 4.12907C6.37644 5.12668 5.37868 6.17324 3.70111 6.14222C3.30668 6.13493 2.99285 5.80927 3.00015 5.41485C3.00744 5.02043 3.3331 4.7066 3.72752 4.71389C4.74046 4.73263 5.1039 4.14714 5.15464 3.87096ZM4.78744 13.6922C4.81467 14.0857 5.15577 14.3827 5.54932 14.3555C5.94287 14.3282 6.23983 13.9871 6.21261 13.5936C6.17161 13.0008 6.05463 12.325 5.65442 11.6893C5.24824 11.0442 4.59803 10.5144 3.62342 10.1229C3.25737 9.97588 2.84141 10.1534 2.69436 10.5195C2.54731 10.8855 2.72486 11.3015 3.09091 11.4485C3.84803 11.7527 4.23186 12.1111 4.44549 12.4504C4.66508 12.7992 4.75368 13.2042 4.78744 13.6922Z"
      fill="currentColor"
    />
  </svg>
);

export const IconInterest = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00002 0.428589C6.63328 0.428589 4.48944 1.38876 2.9391 2.9391C1.38876 4.48944 0.428589 6.63328 0.428589 9.00002C0.428589 11.3668 1.38876 13.5106 2.9391 15.0609C4.48944 16.6113 6.63328 17.5714 9.00002 17.5714C11.3668 17.5714 13.5106 16.6113 15.0609 15.0609C16.6113 13.5106 17.5714 11.3668 17.5714 9.00002C17.5714 6.63328 16.6113 4.48944 15.0609 2.9391C13.5106 1.38876 11.3668 0.428589 9.00002 0.428589ZM3.94925 3.94925C5.24264 2.65587 7.02737 1.85716 9.00002 1.85716C10.9727 1.85716 12.7574 2.65587 14.0508 3.94925C15.3442 5.24264 16.1429 7.02737 16.1429 9.00002C16.1429 10.9727 15.3442 12.7574 14.0508 14.0508C12.7574 15.3442 10.9727 16.1429 9.00002 16.1429C7.02737 16.1429 5.24264 15.3442 3.94925 14.0508C2.65587 12.7574 1.85716 10.9727 1.85716 9.00002C1.85716 7.02737 2.65587 5.24264 3.94925 3.94925ZM7.1585 5.42859C5.62524 5.42859 4.35716 6.66653 4.35716 8.21446C4.35716 9.01939 4.57558 9.65592 5.0937 10.2974C5.56884 10.8857 6.30363 11.4841 7.29035 12.2564L7.29257 12.2581L8.3132 13.0505C8.71721 13.3641 9.28282 13.3641 9.68684 13.0505L10.7075 12.2581L10.7097 12.2564C11.6964 11.4841 12.4312 10.8857 12.9063 10.2974C13.4245 9.65592 13.6429 9.01939 13.6429 8.21446C13.6429 6.66653 12.3748 5.42859 10.8415 5.42859C10.1412 5.42859 9.52354 5.66725 8.99675 6.09803C8.46821 5.66875 7.85326 5.42859 7.1585 5.42859ZM5.78573 8.21446C5.78573 7.46956 6.40009 6.85716 7.1585 6.85716C7.60146 6.85716 8.02571 7.04806 8.44832 7.56196C8.58481 7.72794 8.78877 7.82365 9.00366 7.82255C9.21855 7.82145 9.42152 7.72367 9.55631 7.55631C9.96414 7.04995 10.3854 6.85716 10.8415 6.85716C11.5999 6.85716 12.2143 7.46956 12.2143 8.21446C12.2143 8.69673 12.1053 9.01554 11.795 9.39979C11.4418 9.83709 10.8473 10.3346 9.83033 11.1305L9.8292 11.1314L9.00002 11.7752L8.17083 11.1314L8.16975 11.1306C7.15275 10.3346 6.55826 9.8371 6.20505 9.39979C5.8947 9.01554 5.78573 8.69673 5.78573 8.21446Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPhone = ({ size = 19 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.93297 2.44825L1.99488 2.38355C3.63954 0.738739 4.71057 0.302765 5.85332 0.959899C6.18204 1.14893 6.49021 1.41352 6.90926 1.83913L8.19464 3.172C8.90461 3.94671 9.06601 4.6898 8.83483 5.56006L8.80298 5.67527L8.76763 5.78982L8.5958 6.29397C8.22802 7.42457 8.38156 8.06246 9.69009 9.37066C11.0508 10.7311 11.686 10.8424 12.9039 10.4168L13.1209 10.3414L13.3833 10.2561L13.4982 10.2242C14.4232 9.97745 15.2046 10.1744 16.0333 11.0025L17.069 12.0029L17.3738 12.3028C17.7118 12.6475 17.9352 12.9205 18.1002 13.2092C18.7533 14.3516 18.3168 15.422 16.6247 17.1078L16.4638 17.2709C16.2111 17.5144 15.9751 17.6888 15.6283 17.8535C15.0463 18.1298 14.3586 18.234 13.5596 18.1229C11.5906 17.8491 9.09338 16.2955 5.92911 13.1321C5.67153 12.8745 5.42483 12.622 5.18876 12.3744L4.73073 11.8855C0.438768 7.22245 0.0601293 4.35795 1.81902 2.56144L1.93297 2.44825ZM5.87324 2.61301C5.59524 2.33894 5.3933 2.17186 5.21527 2.06948C4.82145 1.84302 4.39625 1.93875 3.60934 2.61604L3.36208 2.83693C3.31896 2.87674 3.27484 2.91807 3.2297 2.96095L2.94617 3.2371L2.92062 3.26902L2.72841 3.46213C2.26391 3.93657 2.04389 4.51562 2.23349 5.51144C2.54461 7.14553 3.96869 9.36226 6.83405 12.2269C9.81964 15.2117 12.0944 16.6269 13.7359 16.8552C14.6928 16.9882 15.1808 16.7565 15.6786 16.2466L16.0582 15.8635C16.2362 15.6772 16.3883 15.5084 16.5167 15.3542L16.6919 15.1334C17.1396 14.5371 17.1805 14.1794 16.989 13.8444C16.9162 13.717 16.8102 13.5772 16.6559 13.4065L16.4467 13.1855L16.3228 13.0615L15.0162 11.7998C14.5796 11.3972 14.2812 11.3401 13.8282 11.4609L13.6974 11.4986L13.1561 11.6823C11.586 12.1894 10.4532 11.9435 8.78514 10.2758C7.05752 8.54866 6.8549 7.39527 7.43376 5.73458L7.4709 5.62787L7.57358 5.31848L7.62406 5.12128C7.71357 4.6921 7.61137 4.39286 7.15002 3.93142C7.13102 3.91243 7.10979 3.89102 7.08668 3.86759L5.87324 2.61301Z"
      fill="currentColor"
    />
  </svg>
);

export const IconClose = ({ size = 35 }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
  >
    <g clipPath="url(#a)">
      <path
        d="M9.583 7.911a1 1 0 0 0-1.414 0l-.258.258a1 1 0 0 0 0 1.414l7.917 7.917-7.917 7.917a1 1 0 0 0 0 1.414l.258.258a1 1 0 0 0 1.414 0l7.917-7.917 7.917 7.917a1 1 0 0 0 1.414 0l.258-.258a1 1 0 0 0 0-1.414L19.172 17.5l7.917-7.917a1 1 0 0 0 0-1.414l-.258-.258a1 1 0 0 0-1.414 0L17.5 15.828 9.583 7.91Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h35v35H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const IconArrowDown = ({ size = 10 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size + 6}
    height={size}
    viewBox="0 0 16 10"
    fill="none"
  >
    <path
      d="M0.46967 0.96967C0.735936 0.703403 1.1526 0.679197 1.44621 0.897052L1.53033 0.96967L8 7.439L14.4697 0.96967C14.7359 0.703403 15.1526 0.679197 15.4462 0.897052L15.5303 0.96967C15.7966 1.23594 15.8208 1.6526 15.6029 1.94621L15.5303 2.03033L8.53033 9.03033C8.26406 9.2966 7.8474 9.3208 7.55379 9.10295L7.46967 9.03033L0.46967 2.03033C0.176777 1.73744 0.176777 1.26256 0.46967 0.96967Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCheckSuccess = ({ size = 33 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size - 1}
    viewBox="0 0 33 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 29C23.6797 29 29.5 23.1797 29.5 16C29.5 8.8203 23.6797 3 16.5 3C9.3203 3 3.5 8.8203 3.5 16C3.5 23.1797 9.3203 29 16.5 29ZM22.716 12.466C23.1575 12.0245 23.1575 11.3088 22.716 10.8673C22.2745 10.4259 21.5588 10.4259 21.1173 10.8673L13.7917 18.193L10.7993 15.2007C10.3579 14.7592 9.64212 14.7592 9.20066 15.2007C8.7592 15.6421 8.7592 16.3579 9.20066 16.7993L12.9923 20.591C13.4338 21.0325 14.1495 21.0325 14.591 20.591L22.716 12.466Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 18 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9853 0.717325C17.4536 1.22617 17.4494 2.04665 16.9759 2.54991L6.82457 13.3409C6.66008 13.5157 6.38222 13.5157 6.21772 13.3409L1.02821 7.8244C0.554785 7.32114 0.550568 6.50066 1.01879 5.99181C1.48702 5.48296 2.25038 5.47843 2.72381 5.98169L6.21772 9.69575C6.38222 9.87061 6.66008 9.87061 6.82457 9.69575L15.2803 0.7072C15.7538 0.203943 16.5171 0.208476 16.9853 0.717325Z"
      fill="currentColor"
    />
  </svg>
);

export const IconClearInput = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.415 22.1211C17.9379 22.1211 22.415 17.6439 22.415 12.1211C22.415 6.59825 17.9379 2.12109 12.415 2.12109C6.89219 2.12109 2.41504 6.59825 2.41504 12.1211C2.41504 17.6439 6.89219 22.1211 12.415 22.1211ZM8.67539 8.38144C9.02252 8.03431 9.58533 8.03431 9.93247 8.38144L12.415 10.8633L14.8976 8.38144C15.218 8.06101 15.7222 8.03636 16.0709 8.3075L16.1547 8.38144C16.5018 8.72858 16.5018 9.29139 16.1547 9.63852L13.6728 12.1211L16.1547 14.6037C16.4751 14.9241 16.4998 15.4283 16.2286 15.777L16.1547 15.8607C15.8076 16.2079 15.2447 16.2079 14.8976 15.8607L12.415 13.3789L9.93247 15.8607C9.61204 16.1812 9.10783 16.2058 8.75913 15.9347L8.67539 15.8607C8.32826 15.5136 8.32826 14.9508 8.67539 14.6037L11.1573 12.1211L8.67539 9.63852C8.35496 9.31809 8.33031 8.81389 8.60144 8.46518L8.67539 8.38144Z"
      fill="#B3BAC5"
    />
  </svg>
);

export const IconProfileSocialFacebook = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="12" cy="12" r="10.5" fill="url(#paint0_linear_465_15290)" />
    <path
      d="M15.9103 15.2112L16.3767 12.2476H13.4589V10.3252C13.4589 9.51428 13.8657 8.7233 15.1726 8.7233H16.5V6.20024C16.5 6.20024 15.2959 6 14.1452 6C11.7411 6 10.1712 7.4197 10.1712 9.98883V12.2476H7.5V15.2112H10.1712V22.3759C10.7075 22.458 11.2562 22.5 11.8151 22.5C12.374 22.5 12.9226 22.458 13.4589 22.3759V15.2112H15.9103Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_465_15290"
        x1="12"
        y1="1.5"
        x2="12"
        y2="22.4377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={isActive ? "#18ACFE" : "#C1C7D0"} />
        <stop offset="1" stopColor={isActive ? "#0163E0" : "#C1C7D0"} />
      </linearGradient>
    </defs>
  </svg>
);

export const IconProfileSocialTwitter = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.53321 21.7143C4.76035 21.7143 2.17558 20.9078 0 19.5162C1.84714 19.6358 5.10692 19.3495 7.1345 17.4155C4.08435 17.2756 2.7088 14.9362 2.52938 13.9365C2.78854 14.0365 4.02454 14.1565 4.72229 13.8766C1.21363 12.9968 0.675367 9.91771 0.79498 8.97798C1.45285 9.43784 2.56925 9.5978 3.00783 9.55781C-0.261606 7.21849 0.914594 3.69951 1.49273 2.93973C3.83899 6.19028 7.35532 8.01592 11.7055 8.11746C11.6234 7.75773 11.5801 7.38322 11.5801 6.99855C11.5801 4.23793 13.8115 2 16.564 2C18.0022 2 19.2981 2.61093 20.2077 3.58815C21.1688 3.36295 22.6151 2.83577 23.3222 2.37989C22.9658 3.65952 21.8562 4.72699 21.1851 5.12264C21.1906 5.1361 21.1796 5.10912 21.1851 5.12264C21.7746 5.03346 23.3698 4.72689 24 4.29933C23.6884 5.01821 22.512 6.21348 21.5466 6.88265C21.7262 14.804 15.6656 21.7143 7.53321 21.7143Z"
      fill={isActive ? "#47ACDF" : "#C1C7D0"}
    />
  </svg>
);

export const IconProfileSocialInstagram = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="1.5"
      y="1.5"
      width="21"
      height="21"
      rx="6"
      fill="url(#paint0_radial_465_15292)"
    />
    <rect
      x="1.5"
      y="1.5"
      width="21"
      height="21"
      rx="6"
      fill="url(#paint1_radial_465_15292)"
    />
    <rect
      x="1.5"
      y="1.5"
      width="21"
      height="21"
      rx="6"
      fill="url(#paint2_radial_465_15292)"
    />
    <path
      d="M17.25 7.875C17.25 8.49632 16.7463 9 16.125 9C15.5037 9 15 8.49632 15 7.875C15 7.25368 15.5037 6.75 16.125 6.75C16.7463 6.75 17.25 7.25368 17.25 7.875Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75ZM12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 11.7C4.5 9.17976 4.5 7.91965 4.99047 6.95704C5.4219 6.11031 6.11031 5.4219 6.95704 4.99047C7.91965 4.5 9.17976 4.5 11.7 4.5H12.3C14.8202 4.5 16.0804 4.5 17.043 4.99047C17.8897 5.4219 18.5781 6.11031 19.0095 6.95704C19.5 7.91965 19.5 9.17976 19.5 11.7V12.3C19.5 14.8202 19.5 16.0804 19.0095 17.043C18.5781 17.8897 17.8897 18.5781 17.043 19.0095C16.0804 19.5 14.8202 19.5 12.3 19.5H11.7C9.17976 19.5 7.91965 19.5 6.95704 19.0095C6.11031 18.5781 5.4219 17.8897 4.99047 17.043C4.5 16.0804 4.5 14.8202 4.5 12.3V11.7ZM11.7 6H12.3C13.5849 6 14.4583 6.00117 15.1334 6.05633C15.7911 6.11006 16.1274 6.20745 16.362 6.32698C16.9265 6.6146 17.3854 7.07354 17.673 7.63803C17.7926 7.87263 17.8899 8.20893 17.9437 8.86656C17.9988 9.54169 18 10.4151 18 11.7V12.3C18 13.5849 17.9988 14.4583 17.9437 15.1334C17.8899 15.7911 17.7926 16.1274 17.673 16.362C17.3854 16.9265 16.9265 17.3854 16.362 17.673C16.1274 17.7926 15.7911 17.8899 15.1334 17.9437C14.4583 17.9988 13.5849 18 12.3 18H11.7C10.4151 18 9.54169 17.9988 8.86656 17.9437C8.20893 17.8899 7.87263 17.7926 7.63803 17.673C7.07354 17.3854 6.6146 16.9265 6.32698 16.362C6.20745 16.1274 6.11006 15.7911 6.05633 15.1334C6.00117 14.4583 6 13.5849 6 12.3V11.7C6 10.4151 6.00117 9.54169 6.05633 8.86656C6.11006 8.20893 6.20745 7.87263 6.32698 7.63803C6.6146 7.07354 7.07354 6.6146 7.63803 6.32698C7.87263 6.20745 8.20893 6.11006 8.86656 6.05633C9.54169 6.00117 10.4151 6 11.7 6Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_465_15292"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9 17.25) rotate(-55.3758) scale(19.1397)"
      >
        <stop stopColor={isActive ? "#B13589" : "#C1C7D0"} />
        <stop offset="0.79309" stopColor={isActive ? "#C62F94" : "#C1C7D0"} />
        <stop offset="1" stopColor={isActive ? "#8A3AC8" : "#C1C7D0"} />
      </radialGradient>
      <radialGradient
        id="paint1_radial_465_15292"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.25 23.25) rotate(-65.1363) scale(16.9457)"
      >
        <stop stopColor={isActive ? "#E0E8B7" : "#C1C7D0"} />
        <stop offset="0.444662" stopColor={isActive ? "#FB8A2E" : "#C1C7D0"} />
        <stop offset="0.71474" stopColor={isActive ? "#E2425C" : "#C1C7D0"} />
        <stop
          offset="1"
          stopColor={isActive ? "#E2425C" : "#C1C7D0"}
          stopOpacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_465_15292"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.375001 2.25) rotate(-8.1301) scale(29.1682 6.23877)"
      >
        <stop offset="0.156701" stopColor={isActive ? "#406ADC" : "#C1C7D0"} />
        <stop offset="0.467799" stopColor={isActive ? "#6A45BE" : "#C1C7D0"} />
        <stop
          offset="1"
          stopColor={isActive ? "#6A45BE" : "#C1C7D0"}
          stopOpacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
);

export const IconProfileSocialLinkedIn = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="1.5"
      y="1.5"
      width="21"
      height="21"
      rx="10.5"
      fill={isActive ? "#1275B1" : "#C1C7D0"}
    />
    <path
      d="M9.46392 7.26911C9.46392 7.97002 8.85639 8.53822 8.10696 8.53822C7.35753 8.53822 6.75 7.97002 6.75 7.26911C6.75 6.5682 7.35753 6 8.10696 6C8.85639 6 9.46392 6.5682 9.46392 7.26911Z"
      fill="white"
    />
    <path d="M6.93557 9.47107H9.25515V16.5H6.93557V9.47107Z" fill="white" />
    <path
      d="M12.9897 9.47107H10.6701V16.5H12.9897C12.9897 16.5 12.9897 14.2872 12.9897 12.9036C12.9897 12.0732 13.2732 11.2392 14.4046 11.2392C15.6833 11.2392 15.6756 12.3259 15.6696 13.1678C15.6618 14.2683 15.6804 15.3914 15.6804 16.5H18V12.7903C17.9804 10.4215 17.3631 9.33006 15.3325 9.33006C14.1265 9.33006 13.379 9.87754 12.9897 10.3729V9.47107Z"
      fill="white"
    />
  </svg>
);

export const IconProfileSocialWhatsApp = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.25C17.799 23.25 22.5 18.549 22.5 12.75C22.5 6.95101 17.799 2.25 12 2.25C6.20101 2.25 1.5 6.95101 1.5 12.75C1.5 14.6332 1.99575 16.4005 2.86386 17.9287L1.5 23.25L6.98615 21.9778C8.47603 22.7891 10.1842 23.25 12 23.25ZM12 21.6346C16.9068 21.6346 20.8846 17.6568 20.8846 12.75C20.8846 7.84316 16.9068 3.86538 12 3.86538C7.09316 3.86538 3.11538 7.84316 3.11538 12.75C3.11538 14.6445 3.70838 16.4006 4.71888 17.8427L3.92308 20.8269L6.95995 20.0677C8.39202 21.0559 10.1284 21.6346 12 21.6346Z"
      fill="#BFC8D0"
    />
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C10.1041 21 8.34516 20.4138 6.89449 19.4127L3.81818 20.1818L4.62432 17.1588C3.60069 15.698 3 13.9192 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      fill="url(#paint0_linear_465_15294)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 13.8832 1.99575 15.6505 2.86386 17.1787L1.5 22.5L6.98615 21.2278C8.47603 22.0391 10.1842 22.5 12 22.5ZM12 20.8846C16.9068 20.8846 20.8846 16.9068 20.8846 12C20.8846 7.09316 16.9068 3.11538 12 3.11538C7.09316 3.11538 3.11538 7.09316 3.11538 12C3.11538 13.8945 3.70838 15.6506 4.71888 17.0927L3.92308 20.0769L6.95995 19.3177C8.39202 20.3059 10.1284 20.8846 12 20.8846Z"
      fill="white"
      stroke="#EBECF0"
      strokeWidth="0.3"
    />
    <path
      d="M9.37502 7.12504C9.12537 6.6236 8.7424 6.668 8.35551 6.668C7.66407 6.668 6.58594 7.49621 6.58594 9.03759C6.58594 10.3008 7.14259 11.6836 9.01831 13.7522C10.8285 15.7485 13.207 16.7812 15.1816 16.7461C17.1563 16.7109 17.5625 15.0117 17.5625 14.4379C17.5625 14.1835 17.4047 14.0566 17.2959 14.0221C16.6231 13.6992 15.382 13.0975 15.0996 12.9844C14.8172 12.8714 14.6698 13.0243 14.5781 13.1075C14.3221 13.3515 13.8144 14.0707 13.6406 14.2325C13.4668 14.3942 13.2077 14.3124 13.0999 14.2512C12.7031 14.092 11.6272 13.6134 10.7696 12.7821C9.70899 11.754 9.64675 11.4002 9.44693 11.0854C9.28707 10.8335 9.40437 10.6789 9.46291 10.6114C9.69142 10.3477 10.007 9.94061 10.1485 9.73832C10.29 9.53602 10.1776 9.22889 10.1102 9.03759C9.82033 8.21488 9.57473 7.52618 9.37502 7.12504Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_465_15294"
        x1="19.875"
        y1="5.25"
        x2="3"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={isActive ? "#5BD066" : "#C1C7D0"} />
        <stop offset="1" stopColor={isActive ? "#27B43E" : "#C1C7D0"} />
      </linearGradient>
    </defs>
  </svg>
);

export const IconProfileUploadBanner = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99517 4.0263C6.33013 3.41752 6.69452 3.01057 7.23523 2.79536C8.22607 2.40137 11.7747 2.40137 12.7648 2.79543C13.3052 3.01053 13.6697 3.41742 14.0049 4.02607L14.3818 4.74869C14.3904 4.76301 14.3983 4.7756 14.4055 4.78643L14.4375 4.83019C14.6092 5.01727 14.8965 5.13029 15.0862 5.13029C16.8795 5.13029 18.3337 6.58412 18.3337 8.37696V13.2061C18.3337 15.493 16.4788 17.3478 14.192 17.3478H5.80866C3.52125 17.3478 1.66699 15.4932 1.66699 13.2061V8.37696C1.66699 6.58412 3.12114 5.13029 4.91449 5.13029C5.10347 5.13029 5.39122 5.01711 5.56319 4.83019C5.56663 4.82645 5.57111 4.82087 5.57653 4.81349L5.61939 4.74776L5.99517 4.0263ZM12.91 4.62911C12.7017 4.25091 12.5135 4.04079 12.3025 3.95682L12.2031 3.92377C11.3455 3.68136 8.36233 3.69238 7.69729 3.95682C7.48644 4.04074 7.29839 4.25076 7.09034 4.62888L6.76962 5.24896L6.69069 5.39182C6.62479 5.50143 6.55888 5.59395 6.48362 5.67595C6.06156 6.13471 5.4372 6.38029 4.91449 6.38029L4.77775 6.3849C3.73845 6.45518 2.91699 7.32048 2.91699 8.37696V13.2061C2.91699 14.8029 4.21165 16.0978 5.80866 16.0978H14.192C15.7885 16.0978 17.0837 14.8026 17.0837 13.2061V8.37696C17.0837 7.27454 16.1892 6.38029 15.0862 6.38029L14.9411 6.37423C14.4506 6.33387 13.8997 6.09293 13.5165 5.6754C13.4423 5.59448 13.3767 5.50262 13.3112 5.39394C13.3018 5.37834 13.2901 5.35782 13.2767 5.33353L13.18 5.15208L12.91 4.62911Z"
      fill="currentColor"
    />
    <path
      d="M14.5869 7.08337C15.0472 7.08337 15.4203 7.45647 15.4203 7.91671C15.4203 8.34407 15.0986 8.6963 14.6841 8.74443L14.5869 8.75004C14.1192 8.75004 13.7461 8.37694 13.7461 7.91671C13.7461 7.48934 14.0678 7.13712 14.4822 7.08898L14.5869 7.08337Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.72559 10.9401C6.72559 9.13155 8.19124 7.66589 9.99975 7.66589C11.8083 7.66589 13.2739 9.13155 13.2739 10.9401C13.2739 12.7486 11.8083 14.2142 9.99975 14.2142C8.19124 14.2142 6.72559 12.7486 6.72559 10.9401ZM12.0239 10.9401C12.0239 9.82191 11.1179 8.91589 9.99975 8.91589C8.8816 8.91589 7.97559 9.82191 7.97559 10.9401C7.97559 12.0582 8.8816 12.9642 9.99975 12.9642C11.1179 12.9642 12.0239 12.0582 12.0239 10.9401Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCloseCircle = ({
  size = 28,
  rectColor = "#F4F5F7",
  pathColor = "#9199A7",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
  >
    <rect width="28" height="28" rx="14" fill={rectColor} />
    <path
      d="M8.51172 7.33333C8.18632 7.00793 7.65874 7.00793 7.33333 7.33333C7.00793 7.65874 7.00793 8.18632 7.33333 8.51172L12.8216 14L7.33333 19.4883C7.00793 19.8137 7.00793 20.3413 7.33333 20.6667C7.65874 20.9921 8.18632 20.9921 8.51172 20.6667L14 15.1784L19.4883 20.6667C19.8137 20.9921 20.3413 20.9921 20.6667 20.6667C20.9921 20.3413 20.9921 19.8137 20.6667 19.4883L15.1784 14L20.6667 8.51172C20.9921 8.18632 20.9921 7.65874 20.6667 7.33333C20.3413 7.00793 19.8137 7.00793 19.4883 7.33333L14 12.8216L8.51172 7.33333Z"
      fill={pathColor}
    />
  </svg>
);

export const IconProfile = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 4}
    height={size}
    viewBox="0 0 16 20"
    fill="none"
  >
    <mask
      id="mask0_2213_6383"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="12"
      width="16"
      height="8"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.4961H15.8399V19.8701H0V12.4961Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2213_6383)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.921 13.9961C3.66 13.9961 1.5 14.7281 1.5 16.1731C1.5 17.6311 3.66 18.3701 7.921 18.3701C12.181 18.3701 14.34 17.6381 14.34 16.1931C14.34 14.7351 12.181 13.9961 7.921 13.9961ZM7.921 19.8701C5.962 19.8701 0 19.8701 0 16.1731C0 12.8771 4.521 12.4961 7.921 12.4961C9.88 12.4961 15.84 12.4961 15.84 16.1931C15.84 19.4891 11.32 19.8701 7.921 19.8701Z"
        fill="currentColor"
      />
    </g>
    <mask
      id="mask1_2213_6383"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="12"
      height="11"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.60986 0.00012207H13.2299V10.6187H2.60986V0.00012207Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_2213_6383)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92089 1.42776C5.77989 1.42776 4.03789 3.16876 4.03789 5.30976C4.03089 7.44376 5.75989 9.18376 7.89189 9.19176L7.92089 9.90576V9.19176C10.0609 9.19176 11.8019 7.44976 11.8019 5.30976C11.8019 3.16876 10.0609 1.42776 7.92089 1.42776ZM7.92089 10.6188H7.8889C4.9669 10.6098 2.59989 8.22676 2.60989 5.30676C2.60989 2.38176 4.99189 -0.000244141 7.92089 -0.000244141C10.8489 -0.000244141 13.2299 2.38176 13.2299 5.30976C13.2299 8.23776 10.8489 10.6188 7.92089 10.6188Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconLocation = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 3}
    height={size}
    viewBox="0 0 17 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32096 6.99491C7.40619 6.99491 6.66206 7.73905 6.66206 8.65476C6.66206 9.56953 7.40619 10.3127 8.32096 10.3127C9.23572 10.3127 9.97985 9.56953 9.97985 8.65476C9.97985 7.73905 9.23572 6.99491 8.32096 6.99491ZM8.32111 11.7346C6.6224 11.7346 5.2403 10.3535 5.2403 8.65476C5.2403 6.9551 6.6224 5.573 8.32111 5.573C10.0198 5.573 11.4019 6.9551 11.4019 8.65476C11.4019 10.3535 10.0198 11.7346 8.32111 11.7346Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1452_8893"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="17"
      height="20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 0.833313H16.1406V19.3182H0.5V0.833313Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_8893)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32005 2.25523C4.79181 2.25523 1.92144 5.15309 1.92144 8.71356C1.92144 13.2438 7.25267 17.6574 8.32005 17.8925C9.38743 17.6565 14.7187 13.2428 14.7187 8.71356C14.7187 5.15309 11.8483 2.25523 8.32005 2.25523ZM8.3201 19.3182C6.61949 19.3182 0.499573 14.0552 0.499573 8.71356C0.499573 4.36819 4.00791 0.833313 8.3201 0.833313C12.6323 0.833313 16.1406 4.36819 16.1406 8.71356C16.1406 14.0552 10.0207 19.3182 8.3201 19.3182Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconAddress = ({ size = 19 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 1}
    height={size}
    viewBox="0 0 18 19"
    fill="none"
  >
    <mask
      id="mask0_1452_124"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="19"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666687 0.833496H17.7499V18.7543H0.666687V0.833496Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_124)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4307 12.7427C11.434 12.7427 12.2507 13.5536 12.2507 14.5502V17.1136C12.2507 17.3277 12.4223 17.4994 12.6423 17.5044H14.2307C15.4823 17.5044 16.4998 16.4994 16.4998 15.2644V7.99442C16.494 7.56942 16.2915 7.16942 15.944 6.90358L10.4498 2.52192C9.71234 1.93775 8.68067 1.93775 7.94067 2.52358L2.484 6.90192C2.12317 7.17608 1.92067 7.57608 1.9165 8.00858V15.2644C1.9165 16.4994 2.934 17.5044 4.18567 17.5044H5.789C6.01484 17.5044 6.19817 17.3252 6.19817 17.1052C6.19817 17.0569 6.204 17.0086 6.214 16.9627V14.5502C6.214 13.5594 7.02567 12.7494 8.0215 12.7427H10.4307ZM14.2307 18.7544H12.6273C11.709 18.7327 11.0007 18.0119 11.0007 17.1136V14.5503C11.0007 14.2428 10.7448 13.9928 10.4307 13.9928H8.02567C7.71817 13.9944 7.464 14.2453 7.464 14.5503V17.1053C7.464 17.1678 7.45567 17.2278 7.43817 17.2844C7.34817 18.1094 6.64317 18.7544 5.789 18.7544H4.18567C2.24484 18.7544 0.666504 17.1886 0.666504 15.2644V8.00275C0.674837 7.17442 1.0565 6.41608 1.71567 5.91692L7.1615 1.54608C8.36067 0.596083 10.0315 0.596082 11.2282 1.54442L16.7132 5.91942C17.3573 6.41025 17.739 7.16692 17.7498 7.98525V15.2644C17.7498 17.1886 16.1715 18.7544 14.2307 18.7544Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconMail = ({ size = 19 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size - 2}
    viewBox="0 0 19 17"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.81407 10.2207C9.25657 10.2207 8.70073 10.0365 8.23573 9.66818L4.49823 6.65485C4.22907 6.43818 4.1874 6.04401 4.40323 5.77568C4.62073 5.50818 5.01407 5.46568 5.2824 5.68151L9.01657 8.69151C9.48573 9.06318 10.1466 9.06318 10.6191 8.68818L14.3157 5.68318C14.5841 5.46401 14.9774 5.50568 15.1957 5.77401C15.4132 6.04151 15.3724 6.43485 15.1049 6.65318L11.4016 9.66318C10.9332 10.0348 10.3732 10.2207 9.81407 10.2207Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1452_949"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="19"
      height="17"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833313 0.666687H18.7499V16.9167H0.833313V0.666687Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_949)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.69909 15.6667H13.8824C13.8841 15.665 13.8908 15.6667 13.8958 15.6667C14.8466 15.6667 15.6899 15.3267 16.3366 14.6809C17.0874 13.9334 17.4999 12.8592 17.4999 11.6567V5.93335C17.4999 3.60585 15.9783 1.91669 13.8824 1.91669H5.70075C3.60492 1.91669 2.08325 3.60585 2.08325 5.93335V11.6567C2.08325 12.8592 2.49659 13.9334 3.24659 14.6809C3.89325 15.3267 4.73742 15.6667 5.68742 15.6667H5.69909ZM5.68492 16.9167C4.39909 16.9167 3.25075 16.45 2.36409 15.5667C1.37659 14.5817 0.833252 13.1934 0.833252 11.6567V5.93335C0.833252 2.93085 2.92575 0.666687 5.70075 0.666687H13.8824C16.6574 0.666687 18.7499 2.93085 18.7499 5.93335V11.6567C18.7499 13.1934 18.2066 14.5817 17.2191 15.5667C16.3333 16.4492 15.1841 16.9167 13.8958 16.9167H13.8824H5.70075H5.68492Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconSocialNetwork = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00199 0.428592L9.00002 0.428589C4.26615 0.428589 0.428589 4.26615 0.428589 9.00002C0.428589 13.7339 4.26615 17.5714 9.00002 17.5714C13.7339 17.5714 17.5714 13.7339 17.5714 9.00002C17.5714 4.2668 13.735 0.429654 9.00199 0.428592ZM10.6527 15.9507C12.5876 15.4924 14.218 14.2471 15.1873 12.5714H12.1277C11.8414 13.6633 11.4497 14.5653 11.054 15.2826C10.9192 15.5269 10.7841 15.7496 10.6527 15.9507ZM12.4181 11.1429H15.8159C16.0283 10.4664 16.1429 9.74659 16.1429 9.00002C16.1429 8.25344 16.0283 7.53362 15.8159 6.85716H12.4181C12.5153 7.51743 12.5714 8.23147 12.5714 9.00002C12.5714 9.76857 12.5153 10.4826 12.4181 11.1429ZM10.9723 6.85716C11.0794 7.50694 11.1429 8.22072 11.1429 9.00002C11.1429 9.77932 11.0794 10.4931 10.9723 11.1429H7.02776C6.92065 10.4931 6.85716 9.77932 6.85716 9.00002C6.85716 8.22072 6.92065 7.50694 7.02776 6.85716H10.9723ZM12.1277 5.42859H15.1873C14.218 3.75297 12.5876 2.50765 10.6527 2.04932C10.7841 2.25047 10.9192 2.4731 11.054 2.71746C11.4497 3.43473 11.8414 4.33677 12.1277 5.42859ZM7.34733 2.04932C5.41246 2.50765 3.78204 3.75297 2.81275 5.42859H5.87238C6.15865 4.33677 6.5503 3.43473 6.94603 2.71746C7.08085 2.4731 7.21598 2.25047 7.34733 2.04932ZM7.35576 5.42859C7.59698 4.62046 7.89847 3.9484 8.19686 3.40757C8.4851 2.88514 8.7715 2.48335 9.00002 2.19885C9.22853 2.48335 9.51494 2.88514 9.80318 3.40757C10.1016 3.9484 10.4031 4.62046 10.6443 5.42859H7.35576ZM5.58193 6.85716H2.18416C1.9717 7.53362 1.85716 8.25344 1.85716 9.00002C1.85716 9.74659 1.9717 10.4664 2.18416 11.1429H5.58193C5.48471 10.4826 5.42859 9.76857 5.42859 9.00002C5.42859 8.23147 5.48471 7.51743 5.58193 6.85716ZM5.87238 12.5714H2.81275C3.78204 14.2471 5.41246 15.4924 7.34733 15.9507C7.21598 15.7496 7.08085 15.5269 6.94603 15.2826C6.5503 14.5653 6.15865 13.6633 5.87238 12.5714ZM7.35576 12.5714H10.6443C10.4031 13.3796 10.1016 14.0516 9.80318 14.5925C9.51494 15.1149 9.22853 15.5167 9.00002 15.8012C8.7715 15.5167 8.4851 15.1149 8.19686 14.5925C7.89847 14.0516 7.59698 13.3796 7.35576 12.5714Z"
      fill="#B3BAC5"
    />
  </svg>
);

export const IconAnnualIncome = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size - 1}
    viewBox="0 0 18 17"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2406 11.2463H13.8673C12.2865 11.2463 10.9998 9.96049 10.999 8.38049C10.999 6.79882 12.2856 5.51216 13.8673 5.51132H17.2406C17.5856 5.51132 17.8656 5.79132 17.8656 6.13632C17.8656 6.48132 17.5856 6.76132 17.2406 6.76132H13.8673C12.9748 6.76216 12.249 7.48799 12.249 8.37966C12.249 9.27049 12.9756 9.99632 13.8673 9.99632H17.2406C17.5856 9.99632 17.8656 10.2763 17.8656 10.6213C17.8656 10.9663 17.5856 11.2463 17.2406 11.2463Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2486 8.953H13.9886C13.6436 8.953 13.3636 8.673 13.3636 8.328C13.3636 7.983 13.6436 7.703 13.9886 7.703H14.2486C14.5936 7.703 14.8736 7.983 14.8736 8.328C14.8736 8.673 14.5936 8.953 14.2486 8.953Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1452_1285"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="17"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666687 0.5H17.8655V16.4774H0.666687V0.5Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_1285)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66472 1.75C3.59805 1.75 1.91638 3.43167 1.91638 5.49833V11.4792C1.91638 13.5458 3.59805 15.2275 5.66472 15.2275H12.868C14.9347 15.2275 16.6155 13.5458 16.6155 11.4792V5.49833C16.6155 3.43167 14.9347 1.75 12.868 1.75H5.66472ZM12.868 16.4775H5.66471C2.90888 16.4775 0.666382 14.235 0.666382 11.4792V5.49833C0.666382 2.74167 2.90888 0.5 5.66471 0.5H12.868C15.6239 0.5 17.8655 2.74167 17.8655 5.49833V11.4792C17.8655 14.235 15.6239 16.4775 12.868 16.4775Z"
        fill="currentColor"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.57052 5.53174H5.07135C4.72635 5.53174 4.44635 5.25174 4.44635 4.90674C4.44635 4.56174 4.72635 4.28174 5.07135 4.28174H9.57052C9.91552 4.28174 10.1955 4.56174 10.1955 4.90674C10.1955 5.25174 9.91552 5.53174 9.57052 5.53174Z"
      fill="currentColor"
    />
  </svg>
);

export const IconEmploymentStatus = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99591 13.5222C8.65091 13.5222 8.37091 13.2422 8.37091 12.8972V10.7831C8.37091 10.4381 8.65091 10.1581 8.99591 10.1581C9.34091 10.1581 9.62091 10.4381 9.62091 10.7831V12.8972C9.62091 13.2422 9.34091 13.5222 8.99591 13.5222Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1452_4496"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="2"
      width="18"
      height="10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666809 2.81668H17.325V11.4092H0.666809V2.81668Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_4496)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.91681 8.49418C3.89681 9.57001 6.39348 10.1592 8.99181 10.1592C11.5951 10.1592 14.0943 9.57001 16.0751 8.49418V5.99251C16.0751 4.93001 15.216 4.06668 14.1585 4.06668H3.84181C2.78014 4.06668 1.91681 4.92668 1.91681 5.98418V8.49418ZM8.99181 11.4092C6.03764 11.4092 3.19014 10.6942 0.975976 9.39751C0.784309 9.28585 0.666809 9.08085 0.666809 8.85835V5.98418C0.666809 4.23751 2.09098 2.81668 3.84181 2.81668H14.1585C15.9051 2.81668 17.3251 4.24085 17.3251 5.99251V8.85835C17.3251 9.08085 17.2068 9.28585 17.016 9.39751C14.8018 10.6942 11.9518 11.4092 8.99181 11.4092Z"
        fill="currentColor"
      />
    </g>
    <mask
      id="mask1_1452_4496"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="0"
      width="8"
      height="5"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.45422 0.66684H12.5376V4.06342H5.45422V0.66684Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_1452_4496)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9126 4.06342C11.5676 4.06342 11.2876 3.78341 11.2876 3.43841V3.13341C11.2876 2.46258 10.7417 1.91675 10.0709 1.91675H7.92089C7.25006 1.91675 6.70422 2.46258 6.70422 3.13341V3.43841C6.70422 3.78341 6.42422 4.06342 6.07922 4.06342C5.73422 4.06342 5.45422 3.78341 5.45422 3.43841V3.13341C5.45422 1.77341 6.56089 0.666748 7.92089 0.666748H10.0709C11.4309 0.666748 12.5376 1.77341 12.5376 3.13341V3.43841C12.5376 3.78341 12.2576 4.06342 11.9126 4.06342Z"
        fill="currentColor"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8291 17.1168H4.16241C2.43324 17.1168 0.97741 15.766 0.846576 14.041L0.688243 11.9502C0.66241 11.606 0.920743 11.3052 1.26491 11.2793C1.61074 11.2668 1.90908 11.511 1.93574 11.856L2.09324 13.946C2.17491 15.0227 3.08324 15.8668 4.16241 15.8668H13.8291C14.9082 15.8668 15.8174 15.0227 15.8982 13.946L16.0566 11.856C16.0832 11.511 16.3891 11.266 16.7274 11.2793C17.0716 11.3052 17.3291 11.606 17.3032 11.9502L17.1449 14.041C17.0141 15.766 15.5582 17.1168 13.8291 17.1168Z"
      fill="currentColor"
    />
  </svg>
);

export const IconIndustry = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size - 4}
    height={size}
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.09697 4.95166e-07C5.7807 -1.03141e-05 5.50781 -1.96372e-05 5.28307 0.0203819C5.04587 0.0419159 4.80993 0.0894598 4.58291 0.217989C4.24421 0.409736 3.96885 0.715697 3.79627 1.09202C3.6806 1.34427 3.63781 1.60642 3.61843 1.86998C3.60006 2.1197 3.60007 2.42287 3.60008 2.77431L3.60008 6.46049C3.42483 6.46049 3.24957 6.48892 3.07998 6.5458C2.85425 6.62149 2.6673 6.75212 2.49298 6.9009C2.29131 7.07303 2.1032 7.26663 1.91429 7.45555L0.794307 8.57547C0.599629 8.76976 0.428037 8.94101 0.300969 9.15344C0.189385 9.33999 0.106797 9.54603 0.0566506 9.76298C-0.000454685 10.01 -0.000225444 10.2663 3.4624e-05 10.5571L6.95286e-05 13.2257C5.87998e-05 13.5771 4.95015e-05 13.8803 0.0184118 14.13C0.0377925 14.3936 0.0805822 14.6557 0.196259 14.908C0.368832 15.2843 0.644198 15.5903 0.982891 15.782C1.20992 15.9105 1.44585 15.9581 1.68306 15.9796C1.9078 16 2.18066 16 2.49694 16H9.50325C9.81953 16 10.0924 16 10.3171 15.9796C10.5543 15.9581 10.7903 15.9105 11.0173 15.782C11.356 15.5903 11.6314 15.2843 11.8039 14.908C11.9196 14.6557 11.9624 14.3936 11.9818 14.13C12.0001 13.8803 12.0001 13.5771 12.0001 13.2257V2.77429C12.0001 2.42287 12.0001 2.11969 11.9818 1.86998C11.9624 1.60642 11.9196 1.34427 11.8039 1.09202C11.6314 0.715697 11.356 0.409736 11.0173 0.217989C10.7903 0.0894598 10.5543 0.0419159 10.3171 0.0203819C10.0924 -1.96372e-05 9.81955 -1.03141e-05 9.50328 4.95166e-07H6.09697ZM5.26978 7.43945C5.0958 7.26546 4.94058 7.11023 4.80009 6.98281V2.8C4.80009 2.41563 4.80056 2.16745 4.81445 1.97856C4.82776 1.79745 4.85037 1.7303 4.86549 1.69734C4.92301 1.5719 5.0148 1.46991 5.1277 1.406C5.15736 1.3892 5.21779 1.36408 5.38079 1.34929C5.5508 1.33385 5.77416 1.33334 6.12009 1.33334H9.48011C9.82604 1.33334 10.0494 1.33385 10.2194 1.34929C10.3824 1.36408 10.4428 1.3892 10.4725 1.406C10.5854 1.46991 10.6772 1.5719 10.7347 1.69734C10.7498 1.7303 10.7724 1.79745 10.7858 1.97856C10.7996 2.16745 10.8001 2.41563 10.8001 2.8V13.2C10.8001 13.5844 10.7996 13.8326 10.7858 14.0214C10.7724 14.2026 10.7498 14.2697 10.7347 14.3027C10.6772 14.4281 10.5854 14.5301 10.4725 14.594C10.4428 14.6108 10.3824 14.6359 10.2194 14.6507C10.0699 14.6643 9.87917 14.6663 9.60011 14.6666V14C9.60011 13.7824 9.60011 13.6736 9.56575 13.5888C9.52664 13.4923 9.45707 13.415 9.37017 13.3715C9.29383 13.3333 9.19592 13.3333 9.00011 13.3333C8.80429 13.3333 8.70639 13.3333 8.63004 13.3715C8.54314 13.415 8.47357 13.4923 8.43446 13.5888C8.4001 13.6736 8.4001 13.7824 8.4001 14V14.6667H7.2001L7.20013 10.5571C7.20039 10.2663 7.20062 10.01 7.14352 9.76298C7.09337 9.54603 7.01078 9.33999 6.8992 9.15344C6.77213 8.94102 6.60055 8.76977 6.40588 8.57549L5.26978 7.43945ZM6.00009 10.6168V14.6667L4.20002 14.6667V13.3333C4.20002 13.1158 4.20002 13.007 4.16566 12.9222C4.12655 12.8256 4.05697 12.7483 3.97008 12.7048C3.89373 12.6667 3.79583 12.6667 3.60001 12.6667C3.4042 12.6667 3.30629 12.6667 3.22995 12.7048C3.14305 12.7483 3.07348 12.8256 3.03437 12.9222C3.00001 13.007 3.00001 13.1158 3.00001 13.3333V14.6667L2.52008 14.6667C2.17415 14.6667 1.95078 14.6661 1.78078 14.6507C1.61778 14.6359 1.55735 14.6108 1.52768 14.594C1.41478 14.5301 1.323 14.4281 1.26547 14.3027C1.25036 14.2697 1.22775 14.2026 1.21443 14.0214C1.20054 13.8326 1.20007 13.5844 1.20007 13.2V10.6168C1.20007 10.2327 1.20448 10.1572 1.21894 10.0946C1.23565 10.0223 1.26318 9.95365 1.30037 9.89147C1.33254 9.83769 1.38011 9.78354 1.63704 9.52661L2.71705 8.44661C2.95099 8.21267 3.10124 8.06305 3.22399 7.95829C3.34084 7.85856 3.39573 7.83265 3.42672 7.82226C3.53978 7.78434 3.66039 7.78434 3.77345 7.82226C3.80443 7.83265 3.85933 7.85856 3.97618 7.95829C4.09893 8.06305 4.24918 8.21267 4.48312 8.44661L5.56312 9.52661C5.82006 9.78354 5.86762 9.83769 5.89979 9.89147C5.93699 9.95365 5.96452 10.0223 5.98123 10.0946C5.99569 10.1572 6.00009 10.2327 6.00009 10.6168ZM6.03445 2.92216C6.00009 3.00698 6.00009 3.11577 6.00009 3.33334C6.00009 3.5509 6.00009 3.65969 6.03445 3.74451C6.07356 3.84107 6.14314 3.91837 6.23003 3.96183C6.30638 4 6.40428 4 6.6001 4C6.79591 4 6.89382 4 6.97016 3.96183C7.05706 3.91837 7.12663 3.84107 7.16574 3.74451C7.2001 3.65969 7.2001 3.5509 7.2001 3.33334C7.2001 3.11577 7.2001 3.00698 7.16574 2.92216C7.12663 2.8256 7.05706 2.7483 6.97016 2.70485C6.89382 2.66667 6.79591 2.66667 6.6001 2.66667C6.40428 2.66667 6.30638 2.66667 6.23003 2.70485C6.14314 2.7483 6.07356 2.8256 6.03445 2.92216ZM8.4001 3.33334C8.4001 3.11577 8.4001 3.00698 8.43446 2.92216C8.47357 2.8256 8.54314 2.7483 8.63004 2.70485C8.70639 2.66667 8.80429 2.66667 9.00011 2.66667C9.19592 2.66667 9.29383 2.66667 9.37017 2.70485C9.45707 2.7483 9.52664 2.8256 9.56575 2.92216C9.60011 3.00698 9.60011 3.11577 9.60011 3.33334C9.60011 3.5509 9.60011 3.65969 9.56575 3.74451C9.52664 3.84107 9.45707 3.91837 9.37017 3.96183C9.29383 4 9.19592 4 9.00011 4C8.80429 4 8.70639 4 8.63004 3.96183C8.54314 3.91837 8.47357 3.84107 8.43446 3.74451C8.4001 3.65969 8.4001 3.5509 8.4001 3.33334ZM8.43446 5.58882C8.4001 5.67365 8.4001 5.78243 8.4001 6C8.4001 6.21757 8.4001 6.32636 8.43446 6.41118C8.47357 6.50774 8.54314 6.58504 8.63004 6.62849C8.70639 6.66667 8.80429 6.66667 9.00011 6.66667C9.19592 6.66667 9.29383 6.66667 9.37017 6.62849C9.45707 6.58504 9.52664 6.50774 9.56575 6.41118C9.60011 6.32636 9.60011 6.21757 9.60011 6C9.60011 5.78243 9.60011 5.67365 9.56575 5.58882C9.52664 5.49227 9.45707 5.41497 9.37017 5.37151C9.29383 5.33334 9.19592 5.33334 9.00011 5.33334C8.80429 5.33334 8.70639 5.33334 8.63004 5.37151C8.54314 5.41497 8.47357 5.49227 8.43446 5.58882ZM6.00009 6C6.00009 5.78243 6.00009 5.67365 6.03445 5.58882C6.07356 5.49227 6.14314 5.41497 6.23003 5.37151C6.30638 5.33334 6.40428 5.33334 6.6001 5.33334C6.79591 5.33334 6.89382 5.33334 6.97016 5.37151C7.05706 5.41497 7.12663 5.49227 7.16574 5.58882C7.2001 5.67365 7.2001 5.78243 7.2001 6C7.2001 6.21757 7.2001 6.32636 7.16574 6.41118C7.12663 6.50774 7.05706 6.58504 6.97016 6.62849C6.89382 6.66667 6.79591 6.66667 6.6001 6.66667C6.40428 6.66667 6.30638 6.66667 6.23003 6.62849C6.14314 6.58504 6.07356 6.50774 6.03445 6.41118C6.00009 6.32636 6.00009 6.21757 6.00009 6ZM8.43446 8.25549C8.4001 8.34032 8.4001 8.4491 8.4001 8.66667C8.4001 8.88424 8.4001 8.99302 8.43446 9.07785C8.47357 9.1744 8.54314 9.2517 8.63004 9.29516C8.70639 9.33334 8.80429 9.33334 9.00011 9.33334C9.19592 9.33334 9.29383 9.33334 9.37017 9.29516C9.45707 9.2517 9.52664 9.1744 9.56575 9.07785C9.60011 8.99302 9.60011 8.88424 9.60011 8.66667C9.60011 8.4491 9.60011 8.34032 9.56575 8.25549C9.52664 8.15894 9.45707 8.08163 9.37017 8.03818C9.29383 8 9.19592 8 9.00011 8C8.80429 8 8.70639 8 8.63004 8.03818C8.54314 8.08163 8.47357 8.15894 8.43446 8.25549ZM8.4001 11.3333C8.4001 11.1158 8.4001 11.007 8.43446 10.9222C8.47357 10.8256 8.54314 10.7483 8.63004 10.7048C8.70639 10.6667 8.80429 10.6667 9.00011 10.6667C9.19592 10.6667 9.29383 10.6667 9.37017 10.7048C9.45707 10.7483 9.52664 10.8256 9.56575 10.9222C9.60011 11.007 9.60011 11.1158 9.60011 11.3333C9.60011 11.5509 9.60011 11.6597 9.56575 11.7445C9.52664 11.8411 9.45707 11.9184 9.37017 11.9618C9.29383 12 9.19592 12 9.00011 12C8.80429 12 8.70639 12 8.63004 11.9618C8.54314 11.9184 8.47357 11.8411 8.43446 11.7445C8.4001 11.6597 8.4001 11.5509 8.4001 11.3333ZM3.00001 10.6667C3.00001 10.4491 3.00001 10.3403 3.03437 10.2555C3.07348 10.1589 3.14305 10.0816 3.22995 10.0382C3.30629 10 3.4042 10 3.60001 10C3.79583 10 3.89373 10 3.97008 10.0382C4.05697 10.0816 4.12655 10.1589 4.16566 10.2555C4.20002 10.3403 4.20002 10.4491 4.20002 10.6667C4.20002 10.8842 4.20002 10.993 4.16566 11.0778C4.12655 11.1744 4.05697 11.2517 3.97008 11.2952C3.89373 11.3333 3.79583 11.3333 3.60001 11.3333C3.4042 11.3333 3.30629 11.3333 3.22995 11.2952C3.14305 11.2517 3.07348 11.1744 3.03437 11.0778C3.00001 10.993 3.00001 10.8842 3.00001 10.6667Z"
      fill="currentColor"
    />
  </svg>
);

export const IconOccupation = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99591 13.5222C8.65091 13.5222 8.37091 13.2422 8.37091 12.8972V10.7831C8.37091 10.4381 8.65091 10.1581 8.99591 10.1581C9.34091 10.1581 9.62091 10.4381 9.62091 10.7831V12.8972C9.62091 13.2422 9.34091 13.5222 8.99591 13.5222Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1452_3892"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="2"
      width="18"
      height="10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666809 2.81667H17.325V11.4092H0.666809V2.81667Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1452_3892)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.91681 8.49417C3.89681 9.57 6.39348 10.1592 8.99181 10.1592C11.5951 10.1592 14.0943 9.57 16.0751 8.49417V5.9925C16.0751 4.93 15.216 4.06667 14.1585 4.06667H3.84181C2.78014 4.06667 1.91681 4.92667 1.91681 5.98417V8.49417ZM8.99181 11.4092C6.03764 11.4092 3.19014 10.6942 0.975976 9.3975C0.784309 9.28583 0.666809 9.08083 0.666809 8.85833V5.98417C0.666809 4.2375 2.09098 2.81667 3.84181 2.81667H14.1585C15.9051 2.81667 17.3251 4.24083 17.3251 5.9925V8.85833C17.3251 9.08083 17.2068 9.28583 17.016 9.3975C14.8018 10.6942 11.9518 11.4092 8.99181 11.4092Z"
        fill="currentColor"
      />
    </g>
    <mask
      id="mask1_1452_3892"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="0"
      width="8"
      height="5"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.45422 0.66684H12.5376V4.06342H5.45422V0.66684Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_1452_3892)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9126 4.06343C11.5676 4.06343 11.2876 3.78343 11.2876 3.43843V3.13343C11.2876 2.4626 10.7417 1.91676 10.0709 1.91676H7.92089C7.25006 1.91676 6.70422 2.4626 6.70422 3.13343V3.43843C6.70422 3.78343 6.42422 4.06343 6.07922 4.06343C5.73422 4.06343 5.45422 3.78343 5.45422 3.43843V3.13343C5.45422 1.77343 6.56089 0.666763 7.92089 0.666763H10.0709C11.4309 0.666763 12.5376 1.77343 12.5376 3.13343V3.43843C12.5376 3.78343 12.2576 4.06343 11.9126 4.06343Z"
        fill="currentColor"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8291 17.1168H4.16241C2.43324 17.1168 0.97741 15.766 0.846576 14.041L0.688243 11.9502C0.66241 11.606 0.920743 11.3052 1.26491 11.2793C1.61074 11.2668 1.90908 11.511 1.93574 11.856L2.09324 13.946C2.17491 15.0227 3.08324 15.8668 4.16241 15.8668H13.8291C14.9082 15.8668 15.8174 15.0227 15.8982 13.946L16.0566 11.856C16.0832 11.511 16.3891 11.266 16.7274 11.2793C17.0716 11.3052 17.3291 11.606 17.3032 11.9502L17.1449 14.041C17.0141 15.766 15.5582 17.1168 13.8291 17.1168Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSubscriptionCOSY = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.448 14.7126C14.4493 14.1335 15.6549 14.3135 16.7273 14.9341L19.5014 16.5345C20.5741 17.1556 21.3303 18.1109 21.3303 19.2666C21.3303 20.4223 20.5741 21.3777 19.5014 21.9987L16.728 23.5987C15.6556 24.2194 14.4493 24.3997 13.448 23.8206C12.4472 23.2418 12.0003 22.1069 12.0003 20.8666V17.6666C12.0003 16.4263 12.4472 15.2914 13.448 14.7126ZM14.0003 17.6666C14.0003 16.8536 14.2801 16.5418 14.4493 16.4439C14.6178 16.3465 15.0252 16.2597 15.726 16.6654L18.4993 18.2654C19.1994 18.6709 19.3303 19.069 19.3303 19.2666C19.3303 19.4642 19.2 19.862 18.4999 20.2675L15.7273 21.8671L15.726 21.8679C15.0252 22.2735 14.6178 22.1868 14.4493 22.0893C14.2801 21.9914 14.0003 21.6796 14.0003 20.8666V17.6666Z"
      fill="#5D5FEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.12655 4.12619C5.90584 2.34689 8.56836 1.66663 12.0003 1.66663H20.0003C23.4323 1.66663 26.0948 2.34689 27.8741 4.12619C29.6534 5.90548 30.3337 8.568 30.3337 12V20C30.3337 23.4319 29.6534 26.0944 27.8741 27.8737C26.0948 29.653 23.4323 30.3333 20.0003 30.3333H12.0003C8.56836 30.3333 5.90584 29.653 4.12655 27.8737C2.34726 26.0944 1.66699 23.4319 1.66699 20V12C1.66699 8.568 2.34726 5.90548 4.12655 4.12619ZM5.54077 5.5404C4.84393 6.23723 4.33208 7.18935 4.02108 8.47994H10.3604V3.73046C8.06498 3.92196 6.54026 4.5409 5.54077 5.5404ZM12.3604 3.66663V8.47994H19.6403V3.66663H12.3604ZM27.9796 8.47994H21.6403V3.73046C23.9357 3.92196 25.4604 4.5409 26.4599 5.5404C27.1567 6.23723 27.6686 7.18935 27.9796 8.47994ZM3.66699 12C3.66699 11.4596 3.68521 10.9537 3.72126 10.4799H28.2794C28.3154 10.9537 28.3337 11.4596 28.3337 12V20C28.3337 23.2347 27.6806 25.2388 26.4599 26.4595C25.2392 27.6802 23.235 28.3333 20.0003 28.3333H12.0003C8.76562 28.3333 6.76147 27.6802 5.54077 26.4595C4.32006 25.2388 3.66699 23.2347 3.66699 20V12Z"
      fill="#5D5FEF"
    />
  </svg>
);

export const IconSubscriptionCourse = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.047 9.64869L17.1927 5.66179L17.191 5.66117C16.3792 5.36962 15.6813 5.36426 14.812 5.65972L3.54378 9.64236C2.37474 10.0601 2.37472 11.7529 3.54378 12.1706L7.75775 13.6763V18.8039C7.75775 19.0792 7.84137 19.3844 8.04964 19.644C8.95067 20.767 11.5365 22.2691 16.0509 22.2691C20.5653 22.2691 23.1511 20.767 24.0521 19.644C24.2604 19.3844 24.344 19.0792 24.344 18.8039V13.5476L25.4986 13.1163V19.706C24.5189 20.1384 23.8354 21.137 23.8354 22.2971C23.8354 23.4571 24.5189 24.4557 25.4986 24.8881V26.8533C25.4986 27.4627 25.9807 27.9644 26.5845 27.9644C27.1884 27.9644 27.6705 27.4627 27.6705 26.8533V24.8881C28.6502 24.4557 29.3337 23.4571 29.3337 22.2971C29.3337 21.137 28.6502 20.1384 27.6705 19.706V12.305L28.047 12.1643C29.193 11.7362 29.193 10.0768 28.047 9.64869ZM15.045 13.9264L6.59333 10.9065L15.045 7.88657C15.6897 7.6562 16.394 7.66125 17.0354 7.90086L25.0814 10.9065L17.0354 13.9121C16.394 14.1517 15.6897 14.1568 15.045 13.9264ZM14.8105 16.269C15.5157 16.5793 16.4791 16.5696 17.1996 16.2693L22.1722 14.3623V18.4352C21.5221 18.9961 19.6498 20.0469 16.0509 20.0469C12.452 20.0469 10.5797 18.9961 9.92958 18.4352V14.4571L14.8105 16.269ZM26.0072 22.2971C26.0072 21.9629 26.2698 21.6995 26.5845 21.6995C26.8992 21.6995 27.1618 21.9629 27.1618 22.2971C27.1618 22.6312 26.8992 22.8946 26.5845 22.8946C26.2698 22.8946 26.0072 22.6312 26.0072 22.2971Z"
      fill="#00BF85"
    />
  </svg>
);

export const IconSubscription = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0004 2.28577C12.2136 2.28577 8.7835 3.82204 6.30295 6.30259C3.82241 8.78314 2.28613 12.2133 2.28613 16.0001C2.28613 19.7868 3.82241 23.217 6.30295 25.6975C8.7835 28.1781 12.2136 29.7143 16.0004 29.7143C19.7872 29.7143 23.2173 28.1781 25.6979 25.6975C28.1784 23.217 29.7147 19.7868 29.7147 16.0001C29.7147 12.2133 28.1784 8.78314 25.6979 6.30259C23.2173 3.82204 19.7872 2.28577 16.0004 2.28577ZM7.9192 7.91883C9.98861 5.84942 12.8442 4.57148 16.0004 4.57148C19.1566 4.57148 22.0122 5.84942 24.0816 7.91883C26.1511 9.98825 27.429 12.8438 27.429 16.0001C27.429 19.1563 26.1511 22.0119 24.0816 24.0813C22.0122 26.1507 19.1566 27.4286 16.0004 27.4286C12.8442 27.4286 9.98861 26.1507 7.9192 24.0813C5.84978 22.0119 4.57185 19.1563 4.57185 16.0001C4.57185 12.8438 5.84978 9.98825 7.9192 7.91883ZM13.054 10.2858C10.6008 10.2858 8.57185 12.2665 8.57185 14.7432C8.57185 16.031 8.92131 17.0495 9.75031 18.0759C10.5105 19.0171 11.6862 19.9746 13.2649 21.2103L13.2685 21.213L14.9015 22.4808C15.5479 22.9827 16.4529 22.9827 17.0993 22.4808L18.7323 21.213L18.7359 21.2103C20.3146 19.9746 21.4903 19.0171 22.2505 18.0759C23.0795 17.0495 23.429 16.031 23.429 14.7432C23.429 12.2665 21.4001 10.2858 18.9468 10.2858C17.8263 10.2858 16.8381 10.6676 15.9952 11.3569C15.1495 10.67 14.1656 10.2858 13.054 10.2858ZM10.8576 14.7432C10.8576 13.5513 11.8405 12.5715 13.054 12.5715C13.7627 12.5715 14.4415 12.8769 15.1177 13.6992C15.3361 13.9647 15.6624 14.1179 16.0062 14.1161C16.3501 14.1144 16.6748 13.9579 16.8905 13.6901C17.543 12.8799 18.217 12.5715 18.9468 12.5715C20.1603 12.5715 21.1433 13.5513 21.1433 14.7432C21.1433 15.5148 20.9689 16.0249 20.4724 16.6397C19.9072 17.3394 18.9561 18.1353 17.3289 19.4089L17.3271 19.4103L16.0004 20.4403L14.6737 19.4103L14.672 19.409C13.0448 18.1354 12.0936 17.3394 11.5285 16.6397C11.0319 16.0249 10.8576 15.5148 10.8576 14.7432Z"
      fill="#EF5DA8"
    />
  </svg>
);

export const IconMembershipStock = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4268 3.1481C10.4431 3.50654 10.4349 3.8297 10.3733 4.15979C10.2915 4.59727 10.1244 5.00406 9.86959 5.50159C9.66554 5.90009 9.38825 6.38836 9.02813 7.0225C8.94483 7.16918 8.8571 7.32366 8.76482 7.48665C8.26908 8.3622 7.62823 9.50667 6.80343 11.0591C4.85444 14.7275 5.71592 17.7233 7.01778 19.6433C6.90897 18.0112 7.35785 16.4104 7.96808 15.0883C8.62338 13.6684 9.49874 12.4966 10.1877 11.8815C10.342 11.7437 10.5439 11.6386 10.7814 11.6226C11.0202 11.6066 11.2329 11.685 11.3956 11.8054C11.7049 12.0344 11.8385 12.4049 11.8415 12.7385C11.8495 13.6405 12.0961 15.1985 12.4574 16.5097C12.6382 17.1658 12.8365 17.7182 13.0273 18.0799C13.0802 18.1802 13.126 18.2531 13.1625 18.3042C13.4054 18.2202 13.7049 18.0753 14.0287 17.8896C14.4288 17.6601 14.8212 17.3947 15.1164 17.1793C15.3054 17.0414 15.5664 16.9424 15.848 16.9715C16.1721 17.005 16.4891 17.2146 16.6046 17.5956C16.719 17.9732 16.7076 18.4452 16.6631 18.8766C16.6396 19.1047 16.6039 19.345 16.5601 19.589C18.8832 16.4056 18.5688 13.2208 17.6668 11.0335C17.3583 13.0265 16.5234 14.4129 15.7709 15.2095C15.4768 15.5208 15.016 15.5832 14.6636 15.339C14.3385 15.1136 14.2203 14.7072 14.3334 14.3401C15.2912 11.2334 14.8628 8.76647 13.9017 6.89663C13.0111 5.16414 11.6454 3.91207 10.4268 3.1481ZM9.09109 2.89484C9.02937 2.0723 9.89489 1.31952 10.7545 1.8092C12.2229 2.64561 13.9632 4.13445 15.0734 6.2943C15.8543 7.81345 16.3133 9.64611 16.1604 11.7808C16.2863 11.3311 16.3825 10.8297 16.433 10.2751C16.4801 9.7572 16.8324 9.36534 17.2673 9.23483C17.7302 9.09591 18.2772 9.26463 18.5444 9.79005C19.886 12.4284 20.635 16.8328 17.0822 21.0566C16.6871 21.5263 16.0934 21.5501 15.6735 21.305C15.2689 21.0688 14.9982 20.5743 15.1259 20.0207C15.2309 19.5656 15.3133 19.1213 15.3525 18.7413C15.3572 18.696 15.3612 18.6526 15.3644 18.6111C15.1515 18.7522 14.9204 18.897 14.6842 19.0325C14.2437 19.2851 13.7371 19.5336 13.2794 19.6413C12.8607 19.7398 12.5283 19.5334 12.3364 19.3545C12.1429 19.1743 11.9877 18.9331 11.8619 18.6945C11.6056 18.2085 11.3774 17.5499 11.1872 16.8596C10.8779 15.7372 10.6396 14.42 10.5561 13.4017C10.1043 13.9433 9.58874 14.7208 9.16435 15.6404C8.56938 16.9295 8.1876 18.4243 8.36115 19.8637C8.42719 20.4114 8.13478 20.8838 7.75875 21.1226C7.5646 21.2459 7.31187 21.3309 7.03382 21.3035C6.74076 21.2746 6.47873 21.1257 6.29216 20.8853C4.58143 18.6813 3.24382 14.9508 5.63992 10.4409C6.47202 8.87477 7.11898 7.71939 7.61831 6.83749C7.71456 6.66751 7.80482 6.50853 7.88952 6.35936C8.24822 5.72764 8.50702 5.27184 8.69687 4.90109C8.92803 4.44965 9.03038 4.17355 9.07814 3.91787C9.12646 3.65917 9.12736 3.37818 9.09109 2.89484ZM10.5236 12.7451C10.5237 12.745 10.5239 12.7463 10.524 12.7493C10.5235 12.7466 10.5235 12.7451 10.5236 12.7451Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
  </svg>
);

export const IconMembershipOption = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4441 1.99994H3.77671C3.30581 2.00073 2.85417 2.18814 2.52118 2.52112C2.1882 2.85411 2.00079 3.30578 2 3.77669V19.3092C2 19.7806 2.18705 20.2328 2.52012 20.5664C2.85319 20.9001 3.30529 21.0879 3.77671 21.0887H8.08675C8.49673 21.0887 8.82908 20.7563 8.82908 20.3464C8.82908 19.9364 8.49673 19.604 8.08675 19.604H3.76849C3.72997 19.604 3.69184 19.5964 3.6563 19.5816C3.62076 19.5668 3.58848 19.5452 3.56132 19.5178C3.53416 19.4905 3.51269 19.4581 3.49813 19.4225C3.48356 19.3869 3.47617 19.3477 3.47641 19.3092V3.77669C3.47641 3.69922 3.50718 3.62493 3.56196 3.57015C3.61674 3.51537 3.69103 3.4846 3.7685 3.4846L16.4369 3.4846C16.4754 3.48436 16.5136 3.49173 16.5492 3.50629C16.5558 3.50899 16.5623 3.51192 16.5686 3.51509C16.6383 3.57411 16.6902 3.65141 16.7183 3.73828L16.7307 3.77668V5.08667V7.6338C16.7307 8.04604 17.0649 8.38022 17.4772 8.38022C17.8894 8.38022 18.2236 8.04604 18.2236 7.6338V3.77643C18.2228 3.30501 18.035 2.85313 17.7013 2.52006C17.3677 2.18699 16.9155 1.99994 16.4441 1.99994Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
    <path
      d="M15.3666 6.49953C15.3666 6.09409 15.0379 5.76542 14.6325 5.76542H5.40215C4.99671 5.76542 4.66803 6.09409 4.66803 6.49953C4.66803 6.90497 4.99671 7.23365 5.40215 7.23365H14.6325C15.0379 7.23365 15.3666 6.90497 15.3666 6.49953Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
    <path
      d="M14.389 11.7612C14.1943 11.7612 14.0076 11.8385 13.8699 11.9762C13.7322 12.1139 13.6549 12.3006 13.6549 12.4953V14.968C13.6549 15.4984 13.8656 16.0071 14.2407 16.3822L16.639 18.7805C16.7767 18.9183 16.9636 18.9956 17.1584 18.9956C17.3532 18.9956 17.54 18.9183 17.6777 18.7805C17.8154 18.6428 17.8928 18.456 17.8928 18.2612C17.8928 18.0664 17.8154 17.8795 17.6776 17.7418L16.9865 17.0513L15.7096 15.7758C15.3341 15.4007 15.1231 14.8917 15.1231 14.3609V13.4772V12.4953C15.1231 12.3006 15.0457 12.1139 14.9081 11.9762C14.7704 11.8385 14.5837 11.7612 14.389 11.7612Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5148 8.76463C13.2059 8.76463 11.9263 9.15283 10.838 9.88011C9.74965 10.6074 8.90143 11.6411 8.40064 12.8505C7.89984 14.0599 7.76896 15.3906 8.02453 16.6743C8.2801 17.9581 8.91067 19.1373 9.83645 20.0627C10.7622 20.9881 11.9416 21.6181 13.2255 21.8731C14.5094 22.1281 15.8401 21.9967 17.0492 21.4954C18.2584 20.9941 19.2917 20.1455 20.0186 19.0568C20.7454 17.9682 21.133 16.6883 21.1325 15.3793C21.1302 13.6252 20.4323 11.9436 19.1916 10.7035C17.951 9.46343 16.269 8.76611 14.5148 8.76463ZM11.6537 11.1009C12.5005 10.535 13.4962 10.2329 14.5147 10.2329C14.9707 10.2331 15.4204 10.2938 15.8531 10.4104C16.7159 10.643 17.5113 11.0983 18.1543 11.7409C18.7974 12.3837 19.2531 13.179 19.4861 14.0419C19.6029 14.4744 19.6638 14.9239 19.6642 15.3797C19.6648 16.3982 19.3632 17.3941 18.7977 18.2412C18.2322 19.0884 17.4282 19.7488 16.4873 20.139C15.5464 20.5291 14.5109 20.6315 13.5119 20.4331C12.5128 20.2347 11.595 19.7445 10.8746 19.0244C10.1541 18.3044 9.66346 17.3868 9.46455 16.3879C9.26564 15.3889 9.36744 14.3534 9.75711 13.4123C10.1468 12.4712 10.8068 11.6668 11.6537 11.1009Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
    <path
      d="M7.98342 10.4223C7.98342 10.0161 7.65413 9.68684 7.24794 9.68684H5.40352C4.99732 9.68684 4.66803 10.0161 4.66803 10.4223C4.66803 10.8285 4.99732 11.1578 5.40352 11.1578H7.24794C7.65413 11.1578 7.98342 10.8285 7.98342 10.4223Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
  </svg>
);

export const IconMembershipCrypto = ({ isActive }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.965 2.80624C17.2538 1.93088 14.3359 1.93088 11.6247 2.80624C10.3014 3.29553 9.57297 4.03226 9.57297 4.87463V8.43871C9.05866 8.39423 8.62218 8.37477 8.21073 8.37477C6.7932 8.35066 5.38223 8.57265 4.04059 9.03087C2.7256 9.53407 2 10.2736 2 11.1104V19.0893C2 19.9233 2.7256 20.6656 4.04059 21.1576C6.75187 22.0324 9.66959 22.0324 12.3809 21.1576C13.4623 20.7462 14.1407 20.1874 14.352 19.5341C14.8278 19.5802 15.3056 19.6025 15.7837 19.6008C17.2013 19.6254 18.6123 19.4034 19.9538 18.9447C21.2716 18.4526 21.9972 17.7159 21.9972 16.8735V4.86351C22.0167 4.03226 21.2827 3.29831 19.965 2.80624ZM14.4242 16.5872C14.8468 16.6289 15.2944 16.6483 15.7865 16.6483C17.2039 16.6738 18.6149 16.4528 19.9566 15.995C20.2325 15.8933 20.5002 15.7706 20.7573 15.628V16.893C20.7573 17.4129 18.8696 18.3664 15.7893 18.3664C15.3344 18.368 14.8797 18.3467 14.427 18.3025L14.4242 16.5872ZM15.7865 15.3973C15.3316 15.3989 14.877 15.3775 14.4242 15.3333V13.6208C14.8468 13.6625 15.2944 13.682 15.7865 13.682C17.2041 13.7066 18.6151 13.4846 19.9566 13.0259C20.2335 12.9265 20.5013 12.8037 20.7573 12.6589V13.9155C20.7545 14.4382 18.8668 15.4001 15.7865 15.4001V15.3973ZM15.7865 12.4365C15.3317 12.4389 14.877 12.4185 14.4242 12.3753V11.1104C14.4237 10.9563 14.3984 10.8033 14.3492 10.6572C14.844 10.7017 15.3167 10.7239 15.7865 10.7239C17.2041 10.7486 18.6151 10.5266 19.9566 10.0678C20.2325 9.96615 20.5002 9.84347 20.7573 9.70087V10.9575C20.7545 11.4607 19.0003 12.4393 15.7865 12.4393V12.4365ZM20.7545 6.57883V7.98833C20.7545 8.49153 19.0003 9.47012 15.7865 9.47012C12.7034 9.47012 10.8185 8.51099 10.8185 7.98833V6.57883C11.0746 6.72143 11.3414 6.84412 11.6163 6.9458C12.9582 7.40302 14.3691 7.62407 15.7865 7.59912C17.2039 7.62463 18.6149 7.40357 19.9566 6.9458C20.2316 6.84398 20.4983 6.7213 20.7545 6.57883ZM15.7865 6.3592C12.7034 6.3592 10.8185 5.39729 10.8185 4.87463C10.8185 4.35197 12.7034 3.38172 15.7865 3.38172C18.8696 3.38172 20.7545 4.34085 20.7545 4.86351C20.7545 5.38617 18.8668 6.3592 15.7865 6.3592ZM13.1815 18.2052V19.1115C13.1815 19.6342 11.2939 20.5933 8.21351 20.5933C5.13317 20.5933 3.24549 19.6453 3.24549 19.1115V18.2052C3.50164 18.3478 3.76839 18.4705 4.04337 18.5722C6.75465 19.4469 9.67238 19.4469 12.3837 18.5722C12.6584 18.4699 12.9251 18.3473 13.1815 18.2052ZM8.21351 17.9772C5.13317 17.9772 3.24549 17.0153 3.24549 16.4926V15.5975C3.50164 15.7401 3.76839 15.8627 4.04337 15.9644C6.75465 16.8392 9.67238 16.8392 12.3837 15.9644C12.6586 15.8627 12.9254 15.7401 13.1815 15.5975V16.501C13.1815 17.0042 11.4273 17.9772 8.21351 17.9772ZM8.21351 15.3695C5.13317 15.3695 3.24549 14.4076 3.24549 13.8849V12.8146C3.50164 12.9572 3.76839 13.0799 4.04337 13.1816C6.75509 14.0535 9.67193 14.0535 12.3837 13.1816C12.6586 13.0799 12.9254 12.9572 13.1815 12.8146V13.8933C13.1815 14.3965 11.4273 15.3778 8.21351 15.3778V15.3695ZM8.21351 12.5894C5.13317 12.5894 3.24549 11.6303 3.24549 11.1076C3.24549 10.5849 5.13317 9.61469 8.21351 9.61469C8.83858 9.6104 9.46308 9.65315 10.0817 9.74257C10.0992 9.74625 10.1171 9.74625 10.1346 9.74257C12.1223 10.0206 13.1927 10.7128 13.1927 11.0965C13.1815 11.6136 11.4273 12.5922 8.21351 12.5922V12.5894Z"
      fill={isActive ? "#2065F6" : "#97A0AF"}
    />
  </svg>
);

export const IconMembershipPremium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect width="20" height="20" rx="10" fill="#FFF6EC" />
    <path
      d="M12.9163 15.8333H7.08301C6.84384 15.8333 6.64551 15.635 6.64551 15.3958C6.64551 15.1566 6.84384 14.9583 7.08301 14.9583H12.9163C13.1555 14.9583 13.3538 15.1566 13.3538 15.3958C13.3538 15.635 13.1555 15.8333 12.9163 15.8333Z"
      fill="#FFA940"
    />
    <path
      d="M14.8705 6.22L12.5371 7.88834C12.228 8.11 11.7846 7.97584 11.6505 7.62L10.548 4.68C10.3613 4.1725 9.64381 4.1725 9.45714 4.68L8.34881 7.61417C8.21464 7.97584 7.77714 8.11 7.46797 7.8825L5.13464 6.21417C4.66797 5.8875 4.04964 6.34834 4.24214 6.89084L6.66881 13.6867C6.75047 13.92 6.97214 14.0717 7.21714 14.0717H12.7763C13.0213 14.0717 13.243 13.9142 13.3246 13.6867L15.7513 6.89084C15.9496 6.34834 15.3313 5.8875 14.8705 6.22ZM11.458 11.6042H8.54131C8.30214 11.6042 8.10381 11.4058 8.10381 11.1667C8.10381 10.9275 8.30214 10.7292 8.54131 10.7292H11.458C11.6971 10.7292 11.8955 10.9275 11.8955 11.1667C11.8955 11.4058 11.6971 11.6042 11.458 11.6042Z"
      fill="#FFA940"
    />
  </svg>
);

export const IconMembershipFree = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect width="20" height="20" rx="10" fill="#FCDDEC" />
    <path
      d="M14.6663 10V13.5C14.6663 14.7892 13.6222 15.8334 12.333 15.8334H7.66634C6.37717 15.8334 5.33301 14.7892 5.33301 13.5V10C5.33301 9.67919 5.59551 9.41669 5.91634 9.41669H7.06551C7.38634 9.41669 7.64884 9.67919 7.64884 10V11.8317C7.64884 12.2634 7.88801 12.66 8.26717 12.8642C8.43634 12.9575 8.62301 13.0042 8.81551 13.0042C9.03717 13.0042 9.25884 12.94 9.45134 12.8117L10.0055 12.45L10.5188 12.7942C10.8747 13.0334 11.3297 13.0625 11.7088 12.8584C12.0938 12.6542 12.333 12.2634 12.333 11.8259V10C12.333 9.67919 12.5955 9.41669 12.9163 9.41669H14.083C14.4038 9.41669 14.6663 9.67919 14.6663 10Z"
      fill="#EF5DA8"
    />
    <path
      d="M15.5413 7.08335V7.66669C15.5413 8.30835 15.2322 8.83335 14.3747 8.83335H5.62467C4.73217 8.83335 4.45801 8.30835 4.45801 7.66669V7.08335C4.45801 6.44169 4.73217 5.91669 5.62467 5.91669H14.3747C15.2322 5.91669 15.5413 6.44169 15.5413 7.08335Z"
      fill="#EF5DA8"
    />
    <path
      d="M9.79028 5.91669H6.57028C6.37195 5.70086 6.37778 5.36836 6.58778 5.15836L7.41611 4.33003C7.63195 4.11419 7.98778 4.11419 8.20361 4.33003L9.79028 5.91669Z"
      fill="#EF5DA8"
    />
    <path
      d="M13.4241 5.91669H10.2041L11.7908 4.33003C12.0066 4.11419 12.3624 4.11419 12.5783 4.33003L13.4066 5.15836C13.6166 5.36836 13.6224 5.70086 13.4241 5.91669Z"
      fill="#EF5DA8"
    />
    <path
      d="M11.149 9.41669C11.4698 9.41669 11.7323 9.67919 11.7323 10V11.8259C11.7323 12.2925 11.2132 12.5725 10.8282 12.31L10.3032 11.96C10.1107 11.8317 9.85984 11.8317 9.66151 11.96L9.11318 12.3217C8.72818 12.5784 8.21484 12.2984 8.21484 11.8375V10C8.21484 9.67919 8.47734 9.41669 8.79818 9.41669H11.149Z"
      fill="#EF5DA8"
    />
  </svg>
);

export const IconClock = ({ size = 14 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99967 1.33331C3.87501 1.33331 1.33301 3.87531 1.33301 6.99998C1.33301 10.1246 3.87501 12.6666 6.99967 12.6666C10.1243 12.6666 12.6663 10.1246 12.6663 6.99998C12.6663 3.87531 10.1243 1.33331 6.99967 1.33331ZM6.99967 13.6666C3.32367 13.6666 0.333008 10.676 0.333008 6.99998C0.333008 3.32398 3.32367 0.333313 6.99967 0.333313C10.6757 0.333313 13.6663 3.32398 13.6663 6.99998C13.6663 10.676 10.6757 13.6666 6.99967 13.6666Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.28677 9.46156C9.19944 9.46156 9.11144 9.43889 9.03077 9.39156L6.51744 7.89222C6.36677 7.80156 6.27344 7.63822 6.27344 7.46222V4.23022C6.27344 3.95422 6.49744 3.73022 6.77344 3.73022C7.0501 3.73022 7.27344 3.95422 7.27344 4.23022V7.17822L9.54344 8.53156C9.7801 8.67356 9.8581 8.98022 9.71677 9.21756C9.62277 9.37422 9.45677 9.46156 9.28677 9.46156Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSearch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4391 14.6678H16.2918L20.8684 19.2659C21.3109 19.7085 21.3109 20.4317 20.8684 20.8742C20.4258 21.3168 19.7026 21.3168 19.2601 20.8742L14.6727 16.2868V15.4341L14.3813 15.1319C12.8701 16.4272 10.8085 17.0964 8.61737 16.7294C5.61669 16.2221 3.22046 13.7179 2.85347 10.6956C2.29219 6.12986 6.13479 2.28726 10.7006 2.84854C13.7229 3.21553 16.227 5.61175 16.7343 8.61244C17.1013 10.8036 16.4321 12.8652 15.1368 14.3763L15.4391 14.6678ZM4.95828 9.81043C4.95828 12.4981 7.12784 14.6676 9.8155 14.6676C12.5032 14.6676 14.6727 12.4981 14.6727 9.81043C14.6727 7.12276 12.5032 4.95321 9.8155 4.95321C7.12784 4.95321 4.95828 7.12276 4.95828 9.81043Z"
      fill="#97A0AF"
    />
  </svg>
);

export const IconVideo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.0001 6.00024C19.8937 6.00024 21.4287 7.53527 21.4287 9.42881V17.1431C21.4287 19.0366 19.8937 20.5717 18.0001 20.5717H6.0001C4.10656 20.5717 2.57153 19.0366 2.57153 17.1431V9.42881C2.57153 7.53527 4.10656 6.00024 6.0001 6.00024H18.0001ZM18.0001 7.71453H6.0001C5.05333 7.71453 4.28582 8.48204 4.28582 9.42881V17.1431C4.28582 18.0899 5.05333 18.8574 6.0001 18.8574H18.0001C18.9469 18.8574 19.7144 18.0899 19.7144 17.1431V9.42881C19.7144 8.48204 18.9469 7.71453 18.0001 7.71453ZM10.7144 10.5606C10.7979 10.5606 10.8795 10.5849 10.9493 10.6307L14.4367 12.9167C14.6347 13.0464 14.69 13.3121 14.5602 13.51C14.5258 13.5625 14.4803 13.6068 14.4269 13.6398L10.9395 15.7923C10.7381 15.9166 10.474 15.8541 10.3497 15.6527C10.3079 15.5851 10.2858 15.5071 10.2858 15.4276V10.9891C10.2858 10.7524 10.4777 10.5606 10.7144 10.5606ZM15.4287 2.57167C16.3324 2.57167 17.0728 3.27099 17.1383 4.15802L17.143 4.28596H6.85725C6.85725 3.33918 7.62476 2.57167 8.57153 2.57167H15.4287Z"
      fill="currentColor"
    />
  </svg>
);

export const IconStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2499 4.50024C12.1589 4.50024 11.9349 4.52524 11.8159 4.76324L9.98992 8.41424C9.70092 8.99124 9.14392 9.39224 8.49992 9.48424L4.41192 10.0732C4.14192 10.1122 4.04992 10.3122 4.02192 10.3962C3.99692 10.4772 3.95692 10.6832 4.14292 10.8612L7.09892 13.7012C7.56992 14.1542 7.78392 14.8072 7.67192 15.4462L6.97592 19.4562C6.93292 19.7072 7.08992 19.8532 7.15992 19.9032C7.23392 19.9592 7.43192 20.0702 7.67692 19.9422L11.3319 18.0472C11.9079 17.7502 12.5939 17.7502 13.1679 18.0472L16.8219 19.9412C17.0679 20.0682 17.2659 19.9572 17.3409 19.9032C17.4109 19.8532 17.5679 19.7072 17.5249 19.4562L16.8269 15.4462C16.7149 14.8072 16.9289 14.1542 17.3999 13.7012L20.3559 10.8612C20.5429 10.6832 20.5029 10.4762 20.4769 10.3962C20.4499 10.3122 20.3579 10.1122 20.0879 10.0732L15.9999 9.48424C15.3569 9.39224 14.7999 8.99124 14.5109 8.41324L12.6829 4.76324C12.5649 4.52524 12.3409 4.50024 12.2499 4.50024ZM7.44692 21.5002C7.03392 21.5002 6.62392 21.3702 6.27292 21.1142C5.66692 20.6702 5.36992 19.9372 5.49892 19.1992L6.19492 15.1892C6.22092 15.0402 6.16992 14.8892 6.05992 14.7832L3.10392 11.9432C2.55992 11.4222 2.36492 10.6522 2.59492 9.93724C2.82692 9.21424 3.44092 8.69724 4.19792 8.58924L8.28592 8.00024C8.44392 7.97824 8.57992 7.88124 8.64792 7.74324L10.4749 4.09124C10.8119 3.41824 11.4919 3.00024 12.2499 3.00024C13.0079 3.00024 13.6879 3.41824 14.0249 4.09124L15.8529 7.74224C15.9219 7.88124 16.0569 7.97824 16.2139 8.00024L20.3019 8.58924C21.0589 8.69724 21.6729 9.21424 21.9049 9.93724C22.1349 10.6522 21.9389 11.4222 21.3949 11.9432L18.4389 14.7832C18.3289 14.8892 18.2789 15.0402 18.3049 15.1882L19.0019 19.1992C19.1299 19.9382 18.8329 20.6712 18.2259 21.1142C17.6109 21.5652 16.8099 21.6262 16.1309 21.2722L12.4779 19.3792C12.3349 19.3052 12.1639 19.3052 12.0209 19.3792L8.36792 21.2732C8.07592 21.4252 7.76092 21.5002 7.44692 21.5002Z"
      fill="currentColor"
    />
  </svg>
);

export const IconRecordItem = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    width={size}
    height={size}
    viewBox="0 0 512.000000 536.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,536.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M2375 5285 c-99 -18 -182 -54 -287 -126 -171 -116 -252 -140 -493 -143 -153 -2 -178 -5 -250 -29 -185 -61 -331 -189 -407 -357 -92 -203 -109 -230 -186 -308 -51 -51 -109 -96 -171 -132 -273 -160 -404 -439 -346 -735 22 -112 23 -250 1 -335 -9 -36 -39 -112 -66 -170 -65 -138 -80 -187 -87 -295 -11 -166 46 -347 148 -474 32 -41 48 -72 61 -125 26 -102 77 -203 140 -277 52 -61 56 -69 63 -134 14 -134 59 -247 143 -356 37 -49 52 -81 65 -134 62 -255 250 -436 527 -509 172 -44 268 -100 366 -212 131 -148 161 -177 227 -221 38 -26 108 -60 156 -77 80 -29 95 -31 221 -31 131 1 138 2 245 40 107 38 113 39 245 39 129 0 140 -2 250 -38 317 -105 595 -24 800 234 116 146 239 224 425 269 137 34 234 89 336 190 70 70 94 102 127 171 44 90 71 189 72 255 0 56 25 163 52 232 31 77 81 150 171 250 129 144 187 287 187 464 0 118 -24 217 -78 326 -63 124 -83 195 -89 313 -4 76 -1 126 11 184 45 216 0 414 -132 587 -35 47 -51 80 -61 124 -28 130 -125 288 -224 366 -27 22 -81 58 -118 80 -152 89 -251 198 -314 348 -51 120 -73 161 -127 228 -81 103 -194 178 -333 223 -59 20 -95 23 -235 26 -245 3 -324 26 -502 146 -180 121 -341 159 -533 123z m258 -124 c88 -23 139 -47 224 -108 81 -58 211 -117 300 -137 47 -10 120 -16 210 -16 159 0 245 -15 330 -58 133 -68 225 -171 283 -317 73 -184 194 -327 360 -425 254 -149 358 -368 305 -643 -22 -113 -19 -264 5 -367 12 -47 43 -131 70 -187 61 -124 80 -194 80 -293 0 -151 -51 -274 -163 -397 -160 -174 -222 -307 -247 -532 -32 -285 -189 -461 -475 -530 -166 -41 -302 -122 -410 -246 -166 -191 -249 -250 -397 -281 -104 -22 -199 -13 -334 32 -94 31 -126 37 -231 41 -137 6 -199 -3 -337 -48 -164 -55 -311 -47 -454 23 -69 34 -141 99 -257 233 -109 125 -238 202 -420 249 -55 15 -129 41 -165 59 -86 43 -184 141 -232 232 -45 88 -56 125 -69 248 -21 200 -93 358 -230 502 -114 121 -168 238 -176 385 -7 111 12 189 77 322 69 143 90 232 90 377 -1 64 -7 145 -15 181 -54 246 53 491 271 618 197 115 315 247 390 437 36 92 104 194 162 245 57 49 187 114 260 129 29 6 117 11 195 11 224 0 333 33 522 159 173 115 310 144 478 102z" />
    </g>
  </svg>
);

export const IconArrowDownFilled = ({ size = 6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size + 4}
    height={size}
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M5.44987 5.31855C5.20142 5.56048 4.79859 5.56048 4.55013 5.31855L0.687619 1.55755C0.286825 1.16729 0.570684 0.500001 1.13749 0.500001L8.86251 0.5C9.42932 0.5 9.71317 1.16729 9.31238 1.55755L5.44987 5.31855Z"
      fill="currentColor"
    />
  </svg>
);

export const IconFilter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.683 14.7737H3.47218C3.0641 14.7737 2.73291 14.4919 2.73291 14.1448C2.73291 13.7976 3.0641 13.5158 3.47218 13.5158H9.683C10.0911 13.5158 10.4223 13.7976 10.4223 14.1448C10.4223 14.4919 10.0911 14.7737 9.683 14.7737Z"
      fill="#2065F6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.205 6.64571H10.242C9.85013 6.64571 9.5321 6.36394 9.5321 6.01676C9.5321 5.66959 9.85013 5.38782 10.242 5.38782H16.205C16.5969 5.38782 16.9149 5.66959 16.9149 6.01676C16.9149 6.36394 16.5969 6.64571 16.205 6.64571Z"
      fill="#2065F6"
    />
    <mask
      id="mask0_999_3735"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="3"
      width="6"
      height="6"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7085 3.37518H7.92942V8.56743H2.7085V3.37518Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_999_3735)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31892 4.63274C4.57341 4.63274 3.96627 5.23317 3.96627 5.97198C3.96627 6.70994 4.57341 7.30954 5.31892 7.30954C6.06527 7.30954 6.67158 6.70994 6.67158 5.97198C6.67158 5.23317 6.06527 4.63274 5.31892 4.63274ZM5.31892 8.56743C3.87989 8.56743 2.70837 7.40346 2.70837 5.97198C2.70837 4.5405 3.87989 3.37485 5.31892 3.37485C6.75879 3.37485 7.92947 4.5405 7.92947 5.97198C7.92947 7.40346 6.75879 8.56743 5.31892 8.56743Z"
        fill="#2065F6"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7739 12.7739C14.0276 12.7739 13.4204 13.3743 13.4204 14.1123C13.4204 14.8511 14.0276 15.4507 14.7739 15.4507C15.5194 15.4507 16.1257 14.8511 16.1257 14.1123C16.1257 13.3743 15.5194 12.7739 14.7739 12.7739ZM14.774 16.7085C13.3341 16.7085 12.1626 15.5437 12.1626 14.1123C12.1626 12.6808 13.3341 11.516 14.774 11.516C16.213 11.516 17.3837 12.6808 17.3837 14.1123C17.3837 15.5437 16.213 16.7085 14.774 16.7085Z"
      fill="#2065F6"
    />
  </svg>
);

export const IconCopy = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.0315 3.40648L16.9983 3.40329C18.8235 3.40329 19.9131 4.55194 19.9131 6.47563V13.8008C19.9131 15.083 19.4264 16.0221 18.5599 16.5043C18.456 16.5621 18.386 16.6687 18.386 16.7876C18.386 17.3901 18.9314 17.914 19.4337 17.5814C20.5445 16.846 21.1922 15.5484 21.1922 13.8839V6.37449C21.1922 3.75812 19.5121 2 17.0109 2L10.89 2.00327C9.29982 2.01306 8.06465 2.69972 7.36959 3.86838C7.09978 4.32204 7.556 4.81273 8.08382 4.80948C8.34164 4.80935 8.5712 4.6598 8.72421 4.4523C9.21705 3.78398 10.0076 3.4128 11.0315 3.40648Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1099_44960"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="5"
      width="15"
      height="17"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.74181H17.4507V22H3V5.74181Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1099_44960)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2568 7.11418L7.28997 7.1173C5.48339 7.1282 4.40317 8.25012 4.40317 10.1192V17.2838C4.40317 19.1654 5.49348 20.2889 7.31791 20.2889L13.2847 20.2865C15.0913 20.2756 16.1715 19.1521 16.1715 17.2838V10.1192C16.1715 8.23765 15.082 7.11418 13.2568 7.11418ZM7.18189 21.6437C4.68073 21.6437 2.99976 19.9241 2.99976 17.3651V10.0202C2.99976 7.43804 4.62822 5.75998 7.14848 5.7448L13.2685 5.74161H13.2693C15.7705 5.74161 17.4507 7.46121 17.4507 10.0202V17.3651C17.4507 19.9465 15.8222 21.6253 13.302 21.6413L7.18189 21.6437Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconSubscriptionId = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size + 4}
    height={size}
    viewBox="0 0 19 15"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.333 3.809C10.988 3.809 10.708 3.529 10.708 3.184V1.1665C10.708 0.821504 10.988 0.541504 11.333 0.541504C11.678 0.541504 11.958 0.821504 11.958 1.1665V3.184C11.958 3.529 11.678 3.809 11.333 3.809Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.333 14.7371C10.988 14.7371 10.708 14.4571 10.708 14.1121V12.4263C10.708 12.0804 10.988 11.8013 11.333 11.8013C11.678 11.8013 11.958 12.0804 11.958 12.4263V14.1121C11.958 14.4571 11.678 14.7371 11.333 14.7371Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.333 10.1879C10.988 10.1879 10.708 9.90791 10.708 9.56291V5.54541C10.708 5.20041 10.988 4.92041 11.333 4.92041C11.678 4.92041 11.958 5.20041 11.958 5.54541V9.56291C11.958 9.90791 11.678 10.1879 11.333 10.1879Z"
      fill="currentColor"
    />
    <mask
      id="mask0_1460_8296"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="19"
      height="15"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833008 0.333496H18.7497V14.9166H0.833008V0.333496Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1460_8296)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.08301 9.96134V11.5772C2.08301 12.7288 3.03551 13.6663 4.20634 13.6663H15.3763C16.5472 13.6663 17.4997 12.7288 17.4997 11.5772V9.96134C16.4572 9.68717 15.6855 8.74384 15.6855 7.62551C15.6855 6.50634 16.4563 5.56384 17.4997 5.28967L17.4988 3.67217C17.4988 2.52051 16.5463 1.58301 15.3755 1.58301H4.20717C3.03634 1.58301 2.08384 2.52051 2.08384 3.67217L2.08301 5.35384C3.13884 5.61301 3.89717 6.51801 3.89717 7.62551C3.89717 8.74384 3.12551 9.68717 2.08301 9.96134M15.3763 14.9163H4.20634C2.34634 14.9163 0.833008 13.418 0.833008 11.5772V9.41717C0.833008 9.07217 1.11301 8.79217 1.45801 8.79217C2.11384 8.79217 2.64717 8.26884 2.64717 7.62551C2.64717 7.00051 2.13551 6.52884 1.45801 6.52884C1.29217 6.52884 1.13301 6.46301 1.01634 6.34551C0.898841 6.22884 0.833008 6.06884 0.833008 5.90384L0.833841 3.67217C0.833841 1.83134 2.34717 0.333008 4.20717 0.333008H15.3755C17.2355 0.333008 18.7488 1.83134 18.7488 3.67217L18.7497 5.83384C18.7497 5.99884 18.6838 6.15884 18.5663 6.27551C18.4497 6.39301 18.2905 6.45884 18.1247 6.45884C17.4688 6.45884 16.9355 6.98217 16.9355 7.62551C16.9355 8.26884 17.4688 8.79217 18.1247 8.79217C18.4697 8.79217 18.7497 9.07217 18.7497 9.41717V11.5772C18.7497 13.418 17.2363 14.9163 15.3763 14.9163"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const IconMoney = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0003 2.2915C5.74313 2.2915 2.29199 5.74264 2.29199 9.99984C2.29199 14.257 5.74313 17.7082 10.0003 17.7082C14.2575 17.7082 17.7087 14.257 17.7087 9.99984C17.7087 5.74264 14.2575 2.2915 10.0003 2.2915ZM1.04199 9.99984C1.04199 5.05229 5.05277 1.0415 10.0003 1.0415C14.9479 1.0415 18.9587 5.05229 18.9587 9.99984C18.9587 14.9474 14.9479 18.9582 10.0003 18.9582C5.05277 18.9582 1.04199 14.9474 1.04199 9.99984ZM10.0003 4.37484C10.3455 4.37484 10.6253 4.65466 10.6253 4.99984V5.49137H10.9352C12.3337 5.49137 13.4102 6.66686 13.4102 8.05804C13.4102 8.40322 13.1304 8.68304 12.7852 8.68304C12.44 8.68304 12.1602 8.40322 12.1602 8.05804C12.1602 7.29922 11.5867 6.74137 10.9352 6.74137H10.6253V9.5532L11.894 9.99394C12.2683 10.1266 12.6742 10.3254 12.974 10.7079C13.2796 11.0977 13.4102 11.5936 13.4102 12.1914C13.4102 13.4429 12.4317 14.508 11.1686 14.508H10.6253V14.9998C10.6253 15.345 10.3455 15.6248 10.0003 15.6248C9.65515 15.6248 9.37533 15.345 9.37533 14.9998V14.508H9.07689C7.67841 14.508 6.60189 13.3326 6.60189 11.9414C6.60189 11.5962 6.88171 11.3164 7.22689 11.3164C7.57207 11.3164 7.85189 11.5962 7.85189 11.9414C7.85189 12.7002 8.42537 13.258 9.07689 13.258H9.37533V10.4422L8.12179 10.0068L8.1181 10.0055C7.74381 9.87281 7.33792 9.67398 7.03813 9.29154C6.73254 8.90171 6.60189 8.40581 6.60189 7.80804C6.60189 6.55647 7.58037 5.49137 8.84355 5.49137H9.37533V4.99984C9.37533 4.65466 9.65515 4.37484 10.0003 4.37484ZM9.37533 6.74137H8.84355C8.3234 6.74137 7.85189 7.19295 7.85189 7.80804C7.85189 8.22694 7.94207 8.41854 8.0219 8.52037C8.10735 8.62938 8.25105 8.72621 8.53396 8.82667C8.53453 8.82687 8.53511 8.82708 8.53568 8.82728L9.37533 9.11896V6.74137ZM10.6253 10.8765V13.258H11.1686C11.6887 13.258 12.1602 12.8065 12.1602 12.1914C12.1602 11.7725 12.07 11.5809 11.9902 11.479C11.9048 11.37 11.7611 11.2732 11.4782 11.1727C11.4776 11.1725 11.477 11.1723 11.4764 11.1721L10.6253 10.8765Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCreditCard = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size + 2}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M12.9932 0.856934C14.5852 0.856934 15.1625 1.02269 15.7445 1.33396C16.3265 1.64522 16.7833 2.10198 17.0945 2.68399C17.4058 3.26601 17.5716 3.8433 17.5716 5.4353V10.5643C17.5716 12.1563 17.4058 12.7336 17.0945 13.3156C16.7833 13.8976 16.3265 14.3544 15.7445 14.6656C15.1625 14.9769 14.5852 15.1426 12.9932 15.1426H5.00708C3.41508 15.1426 2.83778 14.9769 2.25577 14.6656C1.67376 14.3544 1.217 13.8976 0.905734 13.3156C0.594471 12.7336 0.428711 12.1563 0.428711 10.5643V5.4353C0.428711 3.8433 0.594471 3.26601 0.905734 2.68399C1.217 2.10198 1.67376 1.64522 2.25577 1.33396C2.83778 1.02269 3.41508 0.856934 5.00708 0.856934H12.9932ZM16.1423 7.2855H1.85657L1.85728 10.9671C1.85728 11.9223 1.95674 12.2686 2.1435 12.6178C2.33025 12.967 2.60431 13.2411 2.95352 13.4279C3.2809 13.6029 3.60579 13.7013 4.43219 13.7129L4.6043 13.7141H13.396C14.3512 13.7141 14.6976 13.6146 15.0468 13.4279C15.396 13.2411 15.67 12.967 15.8568 12.6178C16.0319 12.2905 16.1302 11.9656 16.1418 11.1392L16.143 10.9671L16.1423 7.2855ZM5.24685 9.42836C5.54182 9.42836 5.66118 9.46151 5.77758 9.52377C5.89399 9.58602 5.98534 9.67737 6.04759 9.79377C6.10984 9.91018 6.143 10.0295 6.143 10.3245V10.6751C6.143 10.97 6.10984 11.0894 6.04759 11.2058C5.98534 11.3222 5.89399 11.4136 5.77758 11.4758C5.66118 11.5381 5.54182 11.5712 5.24685 11.5712H4.89628C4.60132 11.5712 4.48195 11.5381 4.36555 11.4758C4.24915 11.4136 4.1578 11.3222 4.09554 11.2058C4.03329 11.0894 4.00014 10.97 4.00014 10.6751V10.3245C4.00014 10.0295 4.03329 9.91018 4.09554 9.79377C4.1578 9.67737 4.24915 9.58602 4.36555 9.52377C4.48195 9.46151 4.60132 9.42836 4.89628 9.42836H5.24685ZM13.396 2.2855H4.6043C3.6491 2.2855 3.30273 2.38496 2.95352 2.57172C2.60431 2.75848 2.33025 3.03254 2.1435 3.38174C1.96841 3.70912 1.87006 4.03402 1.85844 4.86041L1.85728 5.03252L1.85657 5.14265H16.1423L16.143 5.03252C16.143 4.07733 16.0435 3.73095 15.8568 3.38174C15.67 3.03254 15.396 2.75848 15.0468 2.57172C14.7194 2.39663 14.3945 2.29828 13.5681 2.28667L13.396 2.2855Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTrashCan = ({ size = 36 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      d="M28.8689 10.0364L26.9566 28.1031C26.7937 30.0226 25.1407 31.5 23.1559 31.5H12.8446C10.8598 31.5 9.20688 30.0226 9.04399 28.1031L7.51319 10.0364H28.8689ZM18.1911 12.9969C17.7698 12.9969 17.4284 13.3282 17.4284 13.737L17.2376 27.0592C17.2376 27.468 17.5791 27.7994 18.0003 27.7994C18.4215 27.7994 18.763 27.468 18.763 27.0592L18.9538 13.737C18.9538 13.3282 18.6123 12.9969 18.1911 12.9969ZM22.7673 12.9969C22.3408 12.9969 21.99 13.3228 21.9715 13.7363L21.0842 27.0599L21.0836 27.0907C21.0836 27.4821 21.4105 27.7994 21.8138 27.7994C22.2403 27.7994 22.5911 27.4734 22.6097 27.0599L23.4969 13.7363L23.4976 13.7055C23.4976 13.3141 23.1706 12.9969 22.7673 12.9969ZM13.6148 12.9969L13.5831 12.9975C13.1802 13.0145 12.8677 13.3453 12.8853 13.7363L13.3909 27.0599C13.4095 27.4734 13.7603 27.7994 14.1868 27.7994C14.1973 27.7994 14.2079 27.7992 14.2185 27.7987C14.6214 27.7817 14.9339 27.451 14.9163 27.0599L14.4107 13.7363C14.3921 13.3228 14.0413 12.9969 13.6148 12.9969ZM19.5257 3.375C21.0896 3.375 22.4336 4.28851 23.022 5.59563L27.7249 5.59537C28.5673 5.59537 29.2503 6.25811 29.2503 7.07562V8.18581C29.2503 8.39019 29.0796 8.55587 28.8689 8.55587L7.51323 8.55587C7.30261 8.55587 7.13187 8.39019 7.13187 8.18581V7.07562C7.13187 6.2581 7.81482 5.59537 8.65729 5.59537L12.9785 5.59563C13.567 4.28851 14.911 3.375 16.4749 3.375H19.5257Z"
      fill="currentColor"
    />
  </svg>
);

export const IconStarFilled = ({ size = 14 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M10.9456 8.54687C10.7729 8.7142 10.6936 8.9562 10.7329 9.19354L11.3256 12.4735C11.3756 12.7515 11.2583 13.0329 11.0256 13.1935C10.7976 13.3602 10.4943 13.3802 10.2456 13.2469L7.29292 11.7069C7.19026 11.6522 7.07626 11.6229 6.95959 11.6195H6.77892C6.71626 11.6289 6.65493 11.6489 6.59893 11.6795L3.64559 13.2269C3.49959 13.3002 3.33426 13.3262 3.17226 13.3002C2.77759 13.2255 2.51426 12.8495 2.57893 12.4529L3.17226 9.17287C3.21159 8.93354 3.13226 8.6902 2.95959 8.5202L0.552258 6.18687C0.350925 5.99154 0.280925 5.6982 0.372925 5.43354C0.462258 5.16954 0.690258 4.97687 0.965592 4.93354L4.27892 4.45287C4.53093 4.42687 4.75226 4.27354 4.86559 4.04687L6.32559 1.05354C6.36026 0.98687 6.40493 0.925537 6.45893 0.873537L6.51892 0.82687C6.55026 0.792203 6.58626 0.763537 6.62626 0.740203L6.69893 0.713537L6.81226 0.66687H7.09293C7.34359 0.69287 7.56426 0.84287 7.67959 1.06687L9.15893 4.04687C9.26559 4.26487 9.47293 4.4162 9.71226 4.45287L13.0256 4.93354C13.3056 4.97354 13.5396 5.16687 13.6323 5.43354C13.7196 5.70087 13.6443 5.9942 13.4389 6.18687L10.9456 8.54687Z"
      fill="currentColor"
    />
  </svg>
);

export const IconRefresh = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.78092 0.923443C9.05986 0.644497 9.51212 0.644497 9.79107 0.923443L11.9339 3.0663C12.2129 3.34525 12.2129 3.79751 11.9339 4.07645L9.79107 6.21931C9.51212 6.49826 9.05986 6.49826 8.78092 6.21931C8.50197 5.94036 8.50197 5.4881 8.78092 5.20916L9.69558 4.29365C6.68133 4.45201 4.28599 6.94625 4.28599 9.99995C4.28599 13.1559 6.84437 15.7142 10.0003 15.7142C13.1562 15.7142 15.7146 13.1559 15.7146 9.99995C15.7146 8.57507 15.192 7.23337 14.2617 6.19285C13.9988 5.89876 14.024 5.44721 14.3181 5.18427C14.6122 4.92133 15.0637 4.94658 15.3267 5.24067C16.4889 6.54061 17.1431 8.22034 17.1431 9.99995C17.1431 13.9448 13.9452 17.1428 10.0003 17.1428C6.05539 17.1428 2.85742 13.9448 2.85742 9.99995C2.85742 6.15246 5.89941 3.01548 9.70946 2.8629L8.78092 1.9336C8.50197 1.65465 8.50197 1.20239 8.78092 0.923443Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSortTable = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.63393 0.483698C3.83419 0.28343 4.15889 0.283429 4.35916 0.483695L6.90277 3.02726C7.10304 3.22753 7.10305 3.55223 6.90278 3.7525C6.70251 3.95277 6.37781 3.95278 6.17754 3.75251L4.50937 2.08436V13.154C4.50937 13.4372 4.27977 13.6668 3.99655 13.6668C3.71332 13.6668 3.48372 13.4372 3.48372 13.154V2.08437L1.81559 3.75251C1.61533 3.95277 1.29063 3.95277 1.09036 3.75251C0.890088 3.55224 0.890088 3.22754 1.09036 3.02727L3.63393 0.483698ZM11.2034 0.333496C11.4866 0.333496 11.7162 0.563094 11.7162 0.846317V11.9159L13.3844 10.2478C13.5846 10.0476 13.9093 10.0476 14.1096 10.2478C14.3099 10.4481 14.3099 10.7728 14.1096 10.9731L11.566 13.5166C11.3658 13.7169 11.0411 13.7169 10.8408 13.5166L8.29718 10.9731C8.09691 10.7728 8.09691 10.4481 8.29718 10.2478C8.49744 10.0476 8.82214 10.0475 9.02241 10.2478L10.6906 11.916V0.846317C10.6906 0.563094 10.9202 0.333496 11.2034 0.333496Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSortTableSingle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    color="#0247fe"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.63878 1.48355C7.83905 1.28328 8.16374 1.28328 8.36401 1.48354L10.9076 4.02711C11.1079 4.22738 11.1079 4.55208 10.9076 4.75235C10.7074 4.95262 10.3827 4.95262 10.1824 4.75236L8.51422 3.08421V14.1539C8.51422 14.4371 8.28462 14.6667 8.0014 14.6667C7.71817 14.6667 7.48858 14.4371 7.48858 14.1539V3.08422L5.82045 4.75235C5.62018 4.95262 5.29548 4.95262 5.09521 4.75235C4.89494 4.55208 4.89494 4.22738 5.09521 4.02711L7.63878 1.48355Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTypingRobo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="33"
    viewBox="0 0 35 33"
    fill="none"
  >
    <path
      d="M30.7109 13.6459H32.8885C33.5299 13.6459 34.0498 14.1658 34.0498 14.8072V27.437C34.0498 28.0784 33.5299 28.5983 32.8885 28.5983H30.7109V13.6459Z"
      fill="#C52828"
    />
    <path
      d="M4.29004 13.6459H2.1125C1.4711 13.6459 0.951143 14.1658 0.951143 14.8072V27.437C0.951143 28.0784 1.4711 28.5983 2.1125 28.5983H4.29004V13.6459Z"
      fill="#C52828"
    />
    <rect
      x="4.29004"
      y="8.85535"
      width="26.4208"
      height="24.0981"
      rx="1.8872"
      fill="#8FA3AD"
    />
    <circle
      cx="23.3073"
      cy="17.1299"
      r="3.26631"
      fill="#FEFEFE"
      stroke="#404040"
      strokeWidth="0.435508"
    />
    <circle
      cx="11.694"
      cy="17.1299"
      r="3.26631"
      fill="#FEFEFE"
      stroke="#404040"
      strokeWidth="0.435508"
    />
    <rect
      x="9.95117"
      y="24.3884"
      width="14.8073"
      height="4.20991"
      rx="2.10496"
      fill="white"
    />
    <rect
      x="12.1289"
      y="24.3884"
      width="0.725847"
      height="4.20991"
      fill="#6D6E6E"
    />
    <rect
      x="14.5967"
      y="24.3884"
      width="0.725847"
      height="4.20991"
      fill="#6D6E6E"
    />
    <rect
      x="17.0645"
      y="24.3884"
      width="0.725847"
      height="4.20991"
      fill="#6D6E6E"
    />
    <rect
      x="19.5322"
      y="24.3884"
      width="0.725847"
      height="4.20991"
      fill="#6D6E6E"
    />
    <rect
      x="22.001"
      y="24.3884"
      width="0.725847"
      height="4.20991"
      fill="#6D6E6E"
    />
    <g clipPath="url(#clip0_2791_87755)">
      <path
        d="M17.5723 18.5817L19.8097 22.5194H15.335L17.5723 18.5817Z"
        fill="#C52828"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2253 5.25045C19.3186 4.91047 20.1125 3.8907 20.1125 2.68551C20.1125 1.20228 18.9101 -0.00012207 17.4268 -0.00012207C15.9436 -0.00012207 14.7412 1.20228 14.7412 2.68551C14.7412 3.89073 15.5351 4.91052 16.6285 5.25048V8.85523H18.2253V5.25045Z"
      fill="#8FA3AD"
    />
    <circle cx="17.5012" cy="2.75816" r="1.16136" fill="#C52828" />
    <defs>
      <clipPath id="clip0_2791_87755">
        <rect
          width="4.50025"
          height="4.06474"
          fill="white"
          transform="translate(15.3232 18.5817)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconArrowTypingRobo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="90"
    viewBox="0 0 64 112"
    fill="none"
  >
    <path
      d="M49.3376 1.01337C48.5166 0.274448 47.252 0.341005 46.5131 1.16203L34.4718 14.5413C33.7328 15.3623 33.7994 16.6269 34.6204 17.3658C35.4414 18.1048 36.706 18.0382 37.4449 17.2172L48.1484 5.32447L60.0411 16.0279C60.8621 16.7668 62.1267 16.7003 62.8656 15.8792C63.6045 15.0582 63.538 13.7936 62.7169 13.0547L49.3376 1.01337ZM1.67849 108.026C0.588316 108.204 -0.15135 109.232 0.0263951 110.322C0.204145 111.412 1.232 112.152 2.32217 111.974L1.67849 108.026ZM46.0025 2.60507C46.7647 17.0874 46.753 41.8411 40.8919 63.8385C35.0117 85.908 23.4745 104.472 1.67849 108.026L2.32217 111.974C26.5261 108.028 38.7546 87.3965 44.7571 64.8683C50.7788 42.268 50.7668 17.0218 49.9969 2.39484L46.0025 2.60507Z"
      fill="url(#paint0_linear_2791_87167)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2791_87167"
        x1="66.2107"
        y1="20.7109"
        x2="-10.757"
        y2="97.2938"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C2FF" />
        <stop offset="0.536458" stopColor="#0D8BFF" />
        <stop offset="1" stopColor="#2C5AFF" />
      </linearGradient>
    </defs>
  </svg>
);

export const DiscoverOverviewIcon = ({ isActive }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: isActive ? "#2065F6" : "#9199A7", transform: "scale(0.8)" }}
  >
    <path
      d="M6.42 11.4697C7.83 11.4697 8.96 12.6107 8.96 14.0307V17.4397C8.96 18.8497 7.83 19.9997 6.42 19.9997H3.04C1.64 19.9997 0.5 18.8497 0.5 17.4397V14.0307C0.5 12.6107 1.64 11.4697 3.04 11.4697H6.42ZM17.9601 11.4697C19.3601 11.4697 20.5001 12.6107 20.5001 14.0307V17.4397C20.5001 18.8497 19.3601 19.9997 17.9601 19.9997H14.5801C13.1701 19.9997 12.0401 18.8497 12.0401 17.4397V14.0307C12.0401 12.6107 13.1701 11.4697 14.5801 11.4697H17.9601ZM6.42 0C7.83 0 8.96 1.15 8.96 2.561V5.97C8.96 7.39 7.83 8.53 6.42 8.53H3.04C1.64 8.53 0.5 7.39 0.5 5.97V2.561C0.5 1.15 1.64 0 3.04 0H6.42ZM17.9601 0C19.3601 0 20.5001 1.15 20.5001 2.561V5.97C20.5001 7.39 19.3601 8.53 17.9601 8.53H14.5801C13.1701 8.53 12.0401 7.39 12.0401 5.97V2.561C12.0401 1.15 13.1701 0 14.5801 0H17.9601Z"
      fill="currentColor"
    />
  </svg>
);

export const DiscoverStocksIcon = ({ isActive }) => (
  <svg
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: isActive ? "#2065F6" : "#9199A7", transform: "scale(1)" }}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.92671 2.1481C6.94301 2.50654 6.93482 2.8297 6.87316 3.15979C6.79144 3.59727 6.62425 4.00406 6.36949 4.50159C6.16543 4.90009 5.88814 5.38836 5.52803 6.0225C5.44473 6.16918 5.357 6.32366 5.26472 6.48665C4.76898 7.3622 4.12813 8.50667 3.30333 10.0591C1.35433 13.7275 2.21582 16.7233 3.51768 18.6433C3.40886 17.0112 3.85775 15.4104 4.46797 14.0883C5.12327 12.6684 5.99863 11.4966 6.68758 10.8815C6.84191 10.7437 7.04379 10.6386 7.28127 10.6226C7.52004 10.6066 7.73281 10.685 7.89544 10.8054C8.20478 11.0344 8.33836 11.4049 8.34135 11.7385C8.34943 12.6405 8.59602 14.1985 8.9573 15.5097C9.13809 16.1658 9.33642 16.7182 9.52719 17.0799C9.58007 17.1802 9.62585 17.2531 9.66243 17.3042C9.90532 17.2202 10.2048 17.0753 10.5286 16.8896C10.9287 16.6601 11.3211 16.3947 11.6163 16.1793C11.8053 16.0414 12.0663 15.9424 12.3479 15.9715C12.672 16.005 12.989 16.2146 13.1045 16.5956C13.2189 16.9732 13.2075 17.4452 13.163 17.8766C13.1395 18.1047 13.1038 18.345 13.06 18.589C15.3831 15.4056 15.0687 12.2208 14.1667 10.0335C13.8582 12.0265 13.0233 13.4129 12.2708 14.2095C11.9767 14.5208 11.5159 14.5832 11.1635 14.339C10.8384 14.1136 10.7202 13.7072 10.8333 13.3401C11.7911 10.2334 11.3627 7.76647 10.4016 5.89663C9.511 4.16414 8.14527 2.91207 6.92671 2.1481ZM5.59098 1.89484C5.52926 1.0723 6.39478 0.31952 7.25443 0.809204C8.72275 1.64561 10.4631 3.13445 11.5733 5.2943C12.3542 6.81345 12.8132 8.64611 12.6603 10.7808C12.7862 10.3311 12.8824 9.82967 12.9329 9.27507C12.98 8.7572 13.3323 8.36534 13.7672 8.23483C14.2301 8.09591 14.7771 8.26463 15.0443 8.79005C16.3859 11.4284 17.1349 15.8328 13.5821 20.0566C13.187 20.5263 12.5933 20.5501 12.1734 20.305C11.7688 20.0688 11.4981 19.5743 11.6258 19.0207C11.7308 18.5656 11.8132 18.1213 11.8524 17.7413C11.8571 17.696 11.8611 17.6526 11.8643 17.6111C11.6514 17.7522 11.4203 17.897 11.1841 18.0325C10.7436 18.2851 10.237 18.5336 9.77929 18.6413C9.36057 18.7398 9.02818 18.5334 8.83625 18.3545C8.64281 18.1743 8.48761 17.9331 8.36179 17.6945C8.10548 17.2085 7.87729 16.5499 7.6871 15.8596C7.37783 14.7372 7.13952 13.42 7.05597 12.4017C6.60416 12.9433 6.08863 13.7208 5.66424 14.6404C5.06927 15.9295 4.68749 17.4243 4.86105 18.8637C4.92709 19.4114 4.63467 19.8838 4.25865 20.1226C4.06449 20.2459 3.81176 20.3309 3.53372 20.3035C3.24065 20.2746 2.97862 20.1257 2.79205 19.8853C1.08132 17.6813 -0.256286 13.9508 2.13982 9.44093C2.97191 7.87477 3.61887 6.71939 4.1182 5.83749C4.21445 5.66751 4.30472 5.50853 4.38942 5.35936C4.74811 4.72764 5.00692 4.27184 5.19676 3.90109C5.42793 3.44965 5.53027 3.17355 5.57803 2.91787C5.62635 2.65917 5.62725 2.37818 5.59098 1.89484ZM7.02346 11.7451C7.02356 11.745 7.02379 11.7463 7.02386 11.7493C7.02339 11.7466 7.02336 11.7451 7.02346 11.7451Z"
      fill="currentColor"
    />
  </svg>
);

export const DiscoverOptionsIcon = ({ isActive }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: isActive ? "#2065F6" : "#9199A7", transform: "scale(1)" }}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9442 -3.05176e-05H2.27676C1.80586 0.000761592 1.35422 0.188171 1.02123 0.521153C0.688248 0.854138 0.500842 1.30581 0.50005 1.77672V17.3092C0.50005 17.7807 0.687101 18.2328 1.02017 18.5665C1.35324 18.9001 1.80534 19.0879 2.27676 19.0887H6.5868C6.99678 19.0887 7.32913 18.7564 7.32913 18.3464C7.32913 17.9364 6.99678 17.6041 6.5868 17.6041H2.26854C2.23002 17.6041 2.19189 17.5964 2.15635 17.5817C2.12081 17.5669 2.08853 17.5452 2.06137 17.5179C2.03421 17.4905 2.01274 17.4582 1.99818 17.4225C1.98361 17.3869 1.97622 17.3477 1.97646 17.3092V1.77672C1.97646 1.69925 2.00723 1.62496 2.06201 1.57018C2.11679 1.5154 2.19108 1.48463 2.26855 1.48463L14.9369 1.48463C14.9755 1.48439 15.0136 1.49176 15.0492 1.50632C15.0558 1.50902 15.0623 1.51195 15.0687 1.51512C15.1384 1.57414 15.1902 1.65144 15.2183 1.73831L15.2308 1.77671V3.0867V5.63383C15.2308 6.04607 15.565 6.38025 15.9772 6.38025C16.3894 6.38025 16.7236 6.04607 16.7236 5.63383V1.77646C16.7228 1.30504 16.535 0.853164 16.2014 0.520093C15.8678 0.187024 15.4156 -3.05176e-05 14.9442 -3.05176e-05Z"
      fill="currentColor"
    />
    <path
      d="M13.8666 4.49957C13.8666 4.09413 13.5379 3.76545 13.1325 3.76545H3.9022C3.49676 3.76545 3.16808 4.09413 3.16808 4.49957C3.16808 4.905 3.49676 5.23368 3.9022 5.23368H13.1325C13.5379 5.23368 13.8666 4.905 13.8666 4.49957Z"
      fill="currentColor"
    />
    <path
      d="M12.889 9.76123C12.6943 9.76123 12.5076 9.83854 12.3699 9.97622C12.2323 10.1139 12.1549 10.3006 12.1549 10.4953V12.968C12.1549 13.4984 12.3656 14.0071 12.7407 14.3822L15.139 16.7806C15.2768 16.9183 15.4636 16.9957 15.6584 16.9957C15.8532 16.9957 16.04 16.9183 16.1778 16.7806C16.3155 16.6428 16.3929 16.456 16.3929 16.2612C16.3929 16.0664 16.3154 15.8795 16.1777 15.7418L15.4865 15.0513L14.2097 13.7758C13.8341 13.4007 13.6231 12.8917 13.6231 12.3609V11.4773V10.4953C13.6231 10.3006 13.5458 10.1139 13.4081 9.97622C13.2704 9.83854 13.0837 9.76123 12.889 9.76123Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0149 6.76466C11.7059 6.76466 10.4264 7.15286 9.33803 7.88014C8.2497 8.60742 7.40148 9.64112 6.90069 10.8505C6.39989 12.0599 6.26901 13.3906 6.52458 14.6744C6.78015 15.9582 7.41072 17.1373 8.3365 18.0627C9.26227 18.9881 10.4417 19.6181 11.7256 19.8731C13.0095 20.1282 14.3401 19.9967 15.5493 19.4954C16.7584 18.9941 17.7918 18.1455 18.5186 17.0569C19.2454 15.9682 19.6331 14.6883 19.6325 13.3794C19.6303 11.6252 18.9323 9.94366 17.6917 8.70356C16.4511 7.46346 14.769 6.76614 13.0149 6.76466ZM10.1537 9.10091C11.0006 8.53498 11.9962 8.2329 13.0148 8.23288C13.4707 8.23312 13.9204 8.29379 14.3532 8.41045C15.216 8.64307 16.0113 9.09831 16.6543 9.74098C17.2974 10.3838 17.7531 11.179 17.9862 12.0419C18.103 12.4744 18.1638 12.9239 18.1643 13.3797C18.1648 14.3983 17.8633 15.3941 17.2978 16.2412C16.7323 17.0884 15.9282 17.7489 14.9873 18.139C14.0464 18.5292 13.011 18.6315 12.0119 18.4331C11.0128 18.2347 10.095 17.7445 9.37462 17.0244C8.65419 16.3044 8.16351 15.3869 7.9646 14.3879C7.76569 13.3889 7.86749 12.3534 8.25716 11.4123C8.64683 10.4712 9.30686 9.66686 10.1537 9.10091Z"
      fill="currentColor"
    />
    <path
      d="M6.48347 8.42235C6.48347 8.01616 6.15418 7.68687 5.74798 7.68687H3.90357C3.49737 7.68687 3.16808 8.01616 3.16808 8.42235C3.16808 8.82855 3.49737 9.15784 3.90357 9.15784H5.74798C6.15418 9.15784 6.48347 8.82855 6.48347 8.42235Z"
      fill="currentColor"
    />
  </svg>
);

export const DiscoverCryptosIcon = ({ isActive }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color: isActive ? "#2065F6" : "#9199A7", transform: "scale(1)" }}
  >
    <path
      d="M18.465 0.806207C15.7538 -0.0691509 12.8359 -0.0691509 10.1247 0.806207C8.80136 1.2955 8.07297 2.03223 8.07297 2.8746V6.43868C7.55866 6.3942 7.12218 6.37474 6.71073 6.37474C5.2932 6.35063 3.88223 6.57262 2.54059 7.03084C1.2256 7.53404 0.5 8.27354 0.5 9.11035V17.0892C0.5 17.9233 1.2256 18.6655 2.54059 19.1576C5.25187 20.0324 8.16959 20.0324 10.8809 19.1576C11.9623 18.7462 12.6407 18.1874 12.852 17.534C13.3278 17.5802 13.8056 17.6024 14.2837 17.6008C15.7013 17.6254 17.1123 17.4034 18.4538 16.9447C19.7716 16.4526 20.4972 15.7159 20.4972 14.8735V2.86348C20.5167 2.03223 19.7827 1.29828 18.465 0.806207ZM12.9242 14.5871C13.3468 14.6288 13.7944 14.6483 14.2865 14.6483C15.7039 14.6738 17.1149 14.4527 18.4566 13.995C18.7325 13.8933 19.0002 13.7706 19.2573 13.628V14.8929C19.2573 15.4128 17.3696 16.3664 14.2893 16.3664C13.8344 16.368 13.3797 16.3466 12.927 16.3025L12.9242 14.5871ZM14.2865 13.3973C13.8316 13.3988 13.377 13.3775 12.9242 13.3333V11.6208C13.3468 11.6625 13.7944 11.6819 14.2865 11.6819C15.7041 11.7066 17.1151 11.4845 18.4566 11.0258C18.7335 10.9265 19.0013 10.8037 19.2573 10.6589V11.9155C19.2545 12.4381 17.3668 13.4 14.2865 13.4V13.3973ZM14.2865 10.4365C13.8317 10.4389 13.377 10.4185 12.9242 10.3753V9.11035C12.9237 8.95625 12.8984 8.80323 12.8492 8.65719C13.344 8.70168 13.8167 8.72392 14.2865 8.72392C15.7041 8.74854 17.1151 8.52653 18.4566 8.06781C18.7325 7.96612 19.0002 7.84344 19.2573 7.70084V8.95744C19.2545 9.46064 17.5003 10.4392 14.2865 10.4392V10.4365ZM19.2545 4.5788V5.9883C19.2545 6.4915 17.5003 7.47009 14.2865 7.47009C11.2034 7.47009 9.31846 6.51096 9.31846 5.9883V4.5788C9.57462 4.7214 9.84137 4.84409 10.1163 4.94577C11.4582 5.40299 12.8691 5.62404 14.2865 5.59909C15.7039 5.6246 17.1149 5.40354 18.4566 4.94577C18.7316 4.84395 18.9983 4.72126 19.2545 4.5788ZM14.2865 4.35917C11.2034 4.35917 9.31846 3.39726 9.31846 2.8746C9.31846 2.35194 11.2034 1.38169 14.2865 1.38169C17.3696 1.38169 19.2545 2.34082 19.2545 2.86348C19.2545 3.38613 17.3668 4.35917 14.2865 4.35917ZM11.6815 16.2052V17.1115C11.6815 17.6341 9.79386 18.5933 6.71351 18.5933C3.63317 18.5933 1.74549 17.6452 1.74549 17.1115V16.2052C2.00164 16.3478 2.26839 16.4704 2.54337 16.5721C5.25465 17.4469 8.17238 17.4469 10.8837 16.5721C11.1584 16.4699 11.4251 16.3472 11.6815 16.2052ZM6.71351 15.9772C3.63317 15.9772 1.74549 15.0153 1.74549 14.4926V13.5974C2.00164 13.74 2.26839 13.8627 2.54337 13.9644C5.25465 14.8392 8.17238 14.8392 10.8837 13.9644C11.1586 13.8627 11.4254 13.74 11.6815 13.5974V14.501C11.6815 15.0041 9.9273 15.9772 6.71351 15.9772ZM6.71351 13.3695C3.63317 13.3695 1.74549 12.4075 1.74549 11.8849V10.8145C2.00164 10.9572 2.26839 11.0798 2.54337 11.1815C5.25509 12.0535 8.17193 12.0535 10.8837 11.1815C11.1586 11.0798 11.4254 10.9572 11.6815 10.8145V11.8932C11.6815 12.3964 9.9273 13.3778 6.71351 13.3778V13.3695ZM6.71351 10.5894C3.63317 10.5894 1.74549 9.63023 1.74549 9.10757C1.74549 8.58491 3.63317 7.61466 6.71351 7.61466C7.33858 7.61037 7.96308 7.65312 8.58174 7.74254C8.59915 7.74622 8.61714 7.74622 8.63456 7.74254C10.6223 8.02055 11.6927 8.7128 11.6927 9.09645C11.6815 9.61355 9.9273 10.5921 6.71351 10.5921V10.5894Z"
      fill="currentColor"
    />
  </svg>
);

export const ContactUsIcon = ({ isLightMode }) => {
  let fillcolor = isLightMode ? "#fff" : "#040D14";
  return (
    <svg width="22.5px" height="22.5px" viewBox="0 0 32 26" version="1.1">
      <g
        id="Main"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-2" transform="translate(0.508387, 0.419355)">
          <path
            d="M8,-6.57252031e-14 L22.9677419,-6.57252031e-14 C27.3860199,-6.65368276e-14 30.9677419,3.581722 30.9677419,8 L30.9677419,17.1612903 C30.9677419,21.5795683 27.3860199,25.1612903 22.9677419,25.1612903 L1.59872116e-14,25.1612903 L1.59872116e-14,25.1612903 L1.59872116e-14,8 C1.54461286e-14,3.581722 3.581722,-6.49135786e-14 8,-6.57252031e-14 Z"
            id="Rectangle"
            fill="#92929D"
          ></path>
          <rect
            id="Rectangle"
            fill={fillcolor}
            x="4.83870968"
            y="7.16129032"
            width="21.483871"
            height="3.67741935"
            rx="1.83870968"
          ></rect>
          <rect
            id="Rectangle"
            fill={fillcolor}
            x="4.83870968"
            y="14.516129"
            width="14"
            height="3.67741935"
            rx="1.83870968"
          ></rect>
        </g>
      </g>
    </svg>
  );
};

export const MonthViewIcon = ({ isSelected }) => {
  let fillcolor = isSelected ? "#0D8BFF" : "#282f48";
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 15.13H14.25C14.5266 15.13 14.75 14.9066 14.75 14.63V6.1925H6.5V15.13ZM14.25 2.63H6.5V5.1925H14.75V3.13C14.75 2.85344 14.5266 2.63 14.25 2.63ZM2.25 3.13V14.63C2.25 14.9066 2.47344 15.13 2.75 15.13H5.5V2.63H2.75C2.47344 2.63 2.25 2.85344 2.25 3.13Z"
        fill={fillcolor}
        fill-opacity="0.85"
      />
    </svg>
  );
};

export const EventViewIcon = ({ isSelected }) => {
  let fillcolor = isSelected ? "#0D8BFF" : "#282f48";
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 1.88H3.5C3.22344 1.88 3 2.10344 3 2.38V5.88H14V2.38C14 2.10344 13.7766 1.88 13.5 1.88ZM7.625 4.255C7.625 4.32375 7.56875 4.38 7.5 4.38H4.625C4.55625 4.38 4.5 4.32375 4.5 4.255V3.505C4.5 3.43625 4.55625 3.38 4.625 3.38H7.5C7.56875 3.38 7.625 3.43625 7.625 3.505V4.255ZM3 15.38C3 15.6566 3.22344 15.88 3.5 15.88H13.5C13.7766 15.88 14 15.6566 14 15.38V11.88H3V15.38ZM12 13.255C12.3453 13.255 12.625 13.5347 12.625 13.88C12.625 14.2253 12.3453 14.505 12 14.505C11.6547 14.505 11.375 14.2253 11.375 13.88C11.375 13.5347 11.6547 13.255 12 13.255ZM3 10.88H14V6.88H3V10.88ZM4.5 8.505C4.5 8.43625 4.55625 8.38 4.625 8.38H7.5C7.56875 8.38 7.625 8.43625 7.625 8.505V9.255C7.625 9.32375 7.56875 9.38 7.5 9.38H4.625C4.55625 9.38 4.5 9.32375 4.5 9.255V8.505Z"
        fill={fillcolor}
        fill-opacity="0.85"
      />
    </svg>
  );
};

export const DiscoverStartIcon = ({ isSelected }) => {
  const fillcolor = isSelected ? "#418AF7" : "#1C1B1F";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1217_5134"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.678223" width="24" height="24" fill="black" />
      </mask>
      <g mask="url(#mask0_1217_5134)">
        <path
          d="M5 21.6782V4.67822H14L14.4 6.67822H20V16.6782H13L12.6 14.6782H7V21.6782H5Z"
          fill={fillcolor}
        />
      </g>
    </svg>
  );
};

export const DiscoverJourneyIcon = ({ isSelected }) => {
  const fillcolor = isSelected ? "#418AF7" : "#1C1B1F";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1128_3789"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.678223" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1128_3789)">
        <path
          d="M13.3 21.4032C13.2 21.4866 13.0958 21.5532 12.9875 21.6032C12.8792 21.6532 12.7583 21.6782 12.625 21.6782C12.4917 21.6782 12.3583 21.6491 12.225 21.5907C12.0917 21.5324 11.975 21.4532 11.875 21.3532C11.1917 20.6199 10.6875 19.8699 10.3625 19.1032C10.0375 18.3366 9.875 17.5282 9.875 16.6782C9.875 16.0616 9.96667 15.4116 10.15 14.7282C10.3333 14.0449 10.65 13.1616 11.1 12.0782C11.4833 11.1282 11.75 10.3991 11.9 9.89072C12.05 9.38239 12.125 8.91156 12.125 8.47822C12.125 7.91156 12 7.38239 11.75 6.89072C11.5 6.39906 11.1083 5.90322 10.575 5.40322C10.475 5.30322 10.3958 5.18656 10.3375 5.05322C10.2792 4.91989 10.25 4.78656 10.25 4.65322C10.25 4.51989 10.275 4.39906 10.325 4.29072C10.375 4.18239 10.4417 4.07822 10.525 3.97822C10.625 3.87822 10.7375 3.80322 10.8625 3.75322C10.9875 3.70322 11.1167 3.67822 11.25 3.67822C11.3833 3.67822 11.5083 3.70322 11.625 3.75322C11.7417 3.80322 11.85 3.86989 11.95 3.95322C12.6833 4.63656 13.2292 5.35322 13.5875 6.10322C13.9458 6.85322 14.125 7.64489 14.125 8.47822C14.125 9.06156 14.0375 9.67406 13.8625 10.3157C13.6875 10.9574 13.3833 11.7949 12.95 12.8282C12.5333 13.8282 12.25 14.5949 12.1 15.1282C11.95 15.6616 11.875 16.1699 11.875 16.6532C11.875 17.2366 11.9958 17.7991 12.2375 18.3407C12.4792 18.8824 12.85 19.4282 13.35 19.9782C13.4333 20.0782 13.5 20.1866 13.55 20.3032C13.6 20.4199 13.625 20.5449 13.625 20.6782C13.625 20.8116 13.6 20.9407 13.55 21.0657C13.5 21.1907 13.4167 21.3032 13.3 21.4032ZM18.175 21.4032C18.075 21.4866 17.9708 21.5532 17.8625 21.6032C17.7542 21.6532 17.6333 21.6782 17.5 21.6782C17.3667 21.6782 17.2333 21.6491 17.1 21.5907C16.9667 21.5324 16.85 21.4532 16.75 21.3532C16.0667 20.6199 15.5625 19.8741 15.2375 19.1157C14.9125 18.3574 14.75 17.5532 14.75 16.7032C14.75 16.0866 14.8417 15.4282 15.025 14.7282C15.2083 14.0282 15.525 13.1449 15.975 12.0782C16.3583 11.1282 16.625 10.4032 16.775 9.90322C16.925 9.40322 17 8.93656 17 8.50322C17 7.93656 16.875 7.39906 16.625 6.89072C16.375 6.38239 15.9833 5.88656 15.45 5.40322C15.35 5.30322 15.275 5.19072 15.225 5.06572C15.175 4.94072 15.15 4.81156 15.15 4.67822C15.15 4.54489 15.1708 4.42406 15.2125 4.31572C15.2542 4.20739 15.3167 4.10322 15.4 4.00322C15.5 3.90322 15.6167 3.82406 15.75 3.76572C15.8833 3.70739 16.0167 3.67822 16.15 3.67822C16.2833 3.67822 16.4042 3.70322 16.5125 3.75322C16.6208 3.80322 16.725 3.86989 16.825 3.95322C17.5583 4.63656 18.1042 5.35322 18.4625 6.10322C18.8208 6.85322 19 7.64489 19 8.47822C19 9.06156 18.9125 9.67406 18.7375 10.3157C18.5625 10.9574 18.2583 11.8032 17.825 12.8532C17.4083 13.8532 17.125 14.6199 16.975 15.1532C16.825 15.6866 16.75 16.1866 16.75 16.6532C16.75 17.2366 16.875 17.8074 17.125 18.3657C17.375 18.9241 17.75 19.4699 18.25 20.0032C18.3333 20.1032 18.3958 20.2116 18.4375 20.3282C18.4792 20.4449 18.5 20.5616 18.5 20.6782C18.5 20.8116 18.475 20.9449 18.425 21.0782C18.375 21.2116 18.2917 21.3199 18.175 21.4032ZM8.425 21.4032C8.325 21.4866 8.22083 21.5532 8.1125 21.6032C8.00417 21.6532 7.88333 21.6782 7.75 21.6782C7.61667 21.6782 7.48333 21.6491 7.35 21.5907C7.21667 21.5324 7.1 21.4532 7 21.3532C6.31667 20.6199 5.8125 19.8741 5.4875 19.1157C5.1625 18.3574 5 17.5532 5 16.7032C5 16.0866 5.09167 15.4282 5.275 14.7282C5.45833 14.0282 5.775 13.1449 6.225 12.0782C6.60833 11.1282 6.875 10.4032 7.025 9.90322C7.175 9.40322 7.25 8.93656 7.25 8.50322C7.25 7.93656 7.125 7.39906 6.875 6.89072C6.625 6.38239 6.23333 5.88656 5.7 5.40322C5.58333 5.30322 5.5 5.19072 5.45 5.06572C5.4 4.94072 5.375 4.81156 5.375 4.67822C5.375 4.54489 5.4 4.41989 5.45 4.30322C5.5 4.18656 5.56667 4.07822 5.65 3.97822C5.75 3.87822 5.8625 3.80322 5.9875 3.75322C6.1125 3.70322 6.24167 3.67822 6.375 3.67822C6.50833 3.67822 6.63333 3.70322 6.75 3.75322C6.86667 3.80322 6.975 3.86989 7.075 3.95322C7.80833 4.63656 8.35417 5.34906 8.7125 6.09072C9.07083 6.83239 9.25 7.62822 9.25 8.47822C9.25 9.06156 9.16667 9.67406 9 10.3157C8.83333 10.9574 8.53333 11.7949 8.1 12.8282C7.68333 13.8282 7.4 14.5949 7.25 15.1282C7.1 15.6616 7.025 16.1699 7.025 16.6532C7.025 17.2366 7.14583 17.8074 7.3875 18.3657C7.62917 18.9241 8 19.4699 8.5 20.0032C8.58333 20.1032 8.64583 20.2116 8.6875 20.3282C8.72917 20.4449 8.75 20.5616 8.75 20.6782C8.75 20.8116 8.725 20.9449 8.675 21.0782C8.625 21.2116 8.54167 21.3199 8.425 21.4032Z"
          fill={fillcolor}
        />
      </g>
    </svg>
  );
};

export const DiscoverSecretIcon = ({ isSelected }) => {
  const fillcolor = isSelected ? "#418AF7" : "#1C1B1F";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1128_3770"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.678223" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1128_3770)">
        <path
          d="M12 21.6782L3 12.6782L12 3.67822L21 12.6782L12 21.6782Z"
          fill={fillcolor}
        />
      </g>
    </svg>
  );
};

export const DiscoverShareIcon = ({ isSelected }) => {
  const fillcolor = isSelected ? "#418AF7" : "#1C1B1F";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1128_3778"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.678223" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1128_3778)">
        <path
          d="M11.1 19.6782H12.85V18.4282C13.6833 18.2782 14.4 17.9532 15 17.4532C15.6 16.9532 15.9 16.2116 15.9 15.2282C15.9 14.5282 15.7 13.8866 15.3 13.3032C14.9 12.7199 14.1 12.2116 12.9 11.7782C11.9 11.4449 11.2083 11.1532 10.825 10.9032C10.4417 10.6532 10.25 10.3116 10.25 9.87822C10.25 9.44489 10.4042 9.10322 10.7125 8.85322C11.0208 8.60322 11.4667 8.47822 12.05 8.47822C12.5833 8.47822 13 8.60739 13.3 8.86572C13.6 9.12406 13.8167 9.44489 13.95 9.82822L15.55 9.17822C15.3667 8.59489 15.0292 8.08656 14.5375 7.65322C14.0458 7.21989 13.5 6.97822 12.9 6.92822V5.67822H11.15V6.92822C10.3167 7.11156 9.66667 7.47822 9.2 8.02822C8.73333 8.57822 8.5 9.19489 8.5 9.87822C8.5 10.6616 8.72917 11.2949 9.1875 11.7782C9.64583 12.2616 10.3667 12.6782 11.35 13.0282C12.4 13.4116 13.1292 13.7532 13.5375 14.0532C13.9458 14.3532 14.15 14.7449 14.15 15.2282C14.15 15.7782 13.9542 16.1824 13.5625 16.4407C13.1708 16.6991 12.7 16.8282 12.15 16.8282C11.6 16.8282 11.1125 16.6574 10.6875 16.3157C10.2625 15.9741 9.95 15.4616 9.75 14.7782L8.1 15.4282C8.33333 16.2282 8.69583 16.8741 9.1875 17.3657C9.67917 17.8574 10.3167 18.1949 11.1 18.3782V19.6782ZM12 22.6782C10.6167 22.6782 9.31667 22.4157 8.1 21.8907C6.88333 21.3657 5.825 20.6532 4.925 19.7532C4.025 18.8532 3.3125 17.7949 2.7875 16.5782C2.2625 15.3616 2 14.0616 2 12.6782C2 11.2949 2.2625 9.99489 2.7875 8.77822C3.3125 7.56156 4.025 6.50322 4.925 5.60322C5.825 4.70322 6.88333 3.99072 8.1 3.46572C9.31667 2.94072 10.6167 2.67822 12 2.67822C13.3833 2.67822 14.6833 2.94072 15.9 3.46572C17.1167 3.99072 18.175 4.70322 19.075 5.60322C19.975 6.50322 20.6875 7.56156 21.2125 8.77822C21.7375 9.99489 22 11.2949 22 12.6782C22 14.0616 21.7375 15.3616 21.2125 16.5782C20.6875 17.7949 19.975 18.8532 19.075 19.7532C18.175 20.6532 17.1167 21.3657 15.9 21.8907C14.6833 22.4157 13.3833 22.6782 12 22.6782Z"
          fill={fillcolor}
        />
      </g>
    </svg>
  );
};
// export const IconFilter = () => {
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M7.74659 11.8191H2.77794C2.45148 11.8191 2.18652 11.5936 2.18652 11.3159C2.18652 11.0382 2.45148 10.8127 2.77794 10.8127H7.74659C8.07305 10.8127 8.33801 11.0382 8.33801 11.3159C8.33801 11.5936 8.07305 11.8191 7.74659 11.8191Z"
//       fill="#2065F6"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M12.9643 5.31662H8.19389C7.8804 5.31662 7.62598 5.0912 7.62598 4.81346C7.62598 4.53572 7.8804 4.3103 8.19389 4.3103H12.9643C13.2778 4.3103 13.5322 4.53572 13.5322 4.81346C13.5322 5.0912 13.2778 5.31662 12.9643 5.31662Z"
//       fill="#2065F6"
//     />
//     <mask
//       id="mask0_2756_13242"
//       style="mask-type:alpha"
//       maskUnits="userSpaceOnUse"
//       x="2"
//       y="2"
//       width="5"
//       height="5"
//     >
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M2.16699 2.7002H6.34373V6.85399H2.16699V2.7002Z"
//         fill="white"
//       />
//     </mask>
//     <g mask="url(#mask0_2756_13242)">
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M4.25543 3.70626C3.65902 3.70626 3.17331 4.18661 3.17331 4.77765C3.17331 5.36803 3.65902 5.8477 4.25543 5.8477C4.85251 5.8477 5.33755 5.36803 5.33755 4.77765C5.33755 4.18661 4.85251 3.70626 4.25543 3.70626ZM4.25543 6.85402C3.10421 6.85402 2.16699 5.92284 2.16699 4.77766C2.16699 3.63247 3.10421 2.69995 4.25543 2.69995C5.40733 2.69995 6.34387 3.63247 6.34387 4.77766C6.34387 5.92284 5.40733 6.85402 4.25543 6.85402Z"
//         fill="#2065F6"
//       />
//     </g>
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M11.8195 10.2192C11.2224 10.2192 10.7367 10.6996 10.7367 11.2899C10.7367 11.881 11.2224 12.3607 11.8195 12.3607C12.4159 12.3607 12.901 11.881 12.901 11.2899C12.901 10.6996 12.4159 10.2192 11.8195 10.2192ZM11.8196 13.367C10.6677 13.367 9.73047 12.4351 9.73047 11.2899C9.73047 10.1447 10.6677 9.21289 11.8196 9.21289C12.9708 9.21289 13.9073 10.1447 13.9073 11.2899C13.9073 12.4351 12.9708 13.367 11.8196 13.367Z"
//       fill="#2065F6"
//     />
//   </svg>;
// };
